(function() {
  'use strict';

  angular
    .module('skogscalcPublik', ['core', 'ngAnimate', 'ngCookies', 'ngTouch', 'ngMessages', 'ui.router', 'ui.bootstrap', 'toastr', 'cgNotify', 'LocalStorageModule', 'ngCookies']);

})();

(function() {
    'use strict';

    angular
        .module('skogscalcPublik')
        .constant('Constants', {
            Tabs: {
                ACTIONS: 0,
                PRICES: 1,
                COMPUTATIONS: 2,
                RESULTS: 3
            }
        })
        .controller('WSpaceController', WSpaceController);

    /** @ngInject */
    function WSpaceController($scope, Constants, $state, $stateParams, $uibModal, $sbpModal, $element, EndpointService, ChartService, CurrentSessionService, notify, $timeout, $window, $document, $log) { //$scope $http

        var vm = this;
        var rawData;
        var resultat_aggregerat = 0;
        var loading = true;
        vm.currentYear = (new Date()).getFullYear();


        $scope.$watchGroup([
            'vm.intaekter',
            'vm.kostnader'
        ], doUpdateSum);

        /* ---------------- TABS ------------------ */
        vm.tabs = Constants.Tabs;

        // The 'Actions' tab is open when workspace loads
        vm.activeTab = vm.tabs.ACTIONS;
        vm.isCollapsed = false;

        // Content is collapsed when no tab is selected
        $scope.$watch('vm.activeTab', function() {
            vm.isCollapsed = (vm.activeTab === null);
        });

        /* --------------- ACTIONS ----------------- */

        // vm.actions = "0";

        vm.actions = {
            avverkning: 0,
            rojning: [],
            gallring: []
        };

        $scope.toggleSelectionGal = function toggleSelectionGal(alder) {
            var idx = vm.actions.gallring.indexOf(alder);

            // Is currently selected
            if (idx > -1) {
                vm.actions.gallring.splice(idx, 1);
            }

            // Is newly selected
            else {
                vm.actions.gallring.push(alder);
            }
        }

        $scope.toggleSelectionRoj = function toggleSelectionRoj(alder) {
            var idx = vm.actions.rojning.indexOf(alder);

            // Is currently selected
            if (idx > -1) {
                vm.actions.rojning.splice(idx, 1);
            }

            // Is newly selected
            else {
                vm.actions.rojning.push(alder);
            }
        }

        $scope.$watchGroup([
            'vm.actions.avverkning'
        ], getPrognos);

        $scope.$watchCollection('vm.actions.gallring', getPrognos);
        $scope.$watchCollection('vm.actions.rojning', getPrognos);

        /* --------------- PRICES ----------------- */

        vm.prices = {
            slutavverkning: 0,
            gallring: 0,
            rojning: 0,
            aterbeskogning: 0
        };

        $scope.$watchGroup([
            'vm.prices.slutavverkning',
            'vm.prices.gallring',
            'vm.prices.rojning',
            'vm.prices.aterbeskogning'
        ], function(newVal, oldVal) {
            getPrognos();
        }, true);

        /* ------------- COMPUTATIONS -------------- */
        vm.computations = [['Ingen', 0], ['Belåning', 1], ['Avkastning', 2]];

        vm.computation = {
            type: 1,
            loan: '',
            interest: '',
            returns: '',
            forestValue: ''
        };

        vm.clearComputation = {
            type: 2,
            loan: 0,
            interest: 0,
            returns: 0,
            forestValue: 0
        }

        vm.activeComp;

        $scope.$watchGroup([
            'vm.computation.loan',
            'vm.computation.interest',
            'vm.computation.type'
        ], function() {
            if(vm.computation.type === 1 && vm.computation.loan > 0 && vm.computation.interest > 0) {
                vm.activeComp = vm.computation;
            } else {
                vm.activeComp = vm.clearComputation;
            }
            getPrognos();








        });

        /* ------------- GRAPHS -------------- */
        vm.graphActive = true;

/*        $scope.$watch('vm.computation.type', function() {

            if((vm.computation.type === 0 || vm.computation.type === 2) &&
                (vm.computation.loan !== 0 || vm.computation.interest !== 0)) {

                vm.computation.loan = 0;
                vm.computation.interest = 0;
                getPrognos();
            }

        });*/

        $scope.$watch('vm.computation.returns', updateForestValue);


        /* ------- WORKSPACE INITIALIZATIONS ------- */
        $scope.$on('$viewContentLoaded', function() {

            /* ONLY TO HANDLE REFRESH FOR NOW!!! */
            if(!CurrentSessionService.GetSkogsbruksplan()) {
                $state.go('start');
            }

            // Initialize charts
            ChartService.SetResultatChart($document[0].getElementById('chart_resultat'));
            ChartService.SetSkogChart($document[0].getElementById('chart_skog'));

            // set default market prices
            getDefaultPrices();

            // Get initial prognos



        });

        function getDefaultPrices() {

            EndpointService.getMarketPrices(
                function(response) {
                    vm.prices.slutavverkning = response.data.slutavverkning;
                    vm.prices.gallring       = response.data.gallring;
                    vm.prices.rojning        = response.data.rojning;
                    vm.prices.aterbeskogning = response.data.aterbeskogning;
                    loading = false;
                    getPrognos();
                },
                function(response) {
                    vm.prices.slutavverkning = 0;
                    vm.prices.gallring       = 0;
                    vm.prices.rojning        = 0;
                    vm.prices.aterbeskogning = 0;
                    loading = false;
                    getPrognos();
                }
            );

        }

        function getPrognos() {

            if (vm.prognosTimeout != undefined) {
                $timeout.cancel(vm.prognosTimeout);
            }

            vm.prognosTimeout = $timeout(function() {

                rawData = {
                    sbp: CurrentSessionService.GetSkogsbruksplan(),
                    actions: vm.actions,
                    prices: vm.prices,
                    computations: vm.activeComp
                }

                EndpointService.getPrognos(
                    function(response) {

                        resultat_aggregerat = response.data.resultat_aggregerat[response.data.resultat_aggregerat.length-1];

                        console.log("prognos: " + resultat_aggregerat);

                        vm.intaekter = {
                            avverkning: response.data.intaekter.avverkning,
                            avverkningTot: 0,
                            gallring: response.data.intaekter.gallring
                        }

                        vm.kostnader = {
                            aterbeskogning: response.data.kostnader.aterbeskogning,
                            aterbeskogningTot: 0,
                            lan: response.data.kostnader.lan,
                            rojning: response.data.kostnader.rojning
                        }

                        for (var i = vm.intaekter.avverkning.length - 1; i >= 0; i--) {
                            vm.intaekter.avverkningTot += vm.intaekter.avverkning[i];
                            vm.kostnader.aterbeskogningTot += vm.kostnader.aterbeskogning[i];
                        }

                        ChartService.SetResultatData(response.data.resultat, response.data.pantbrevskostnad, response.data.resultat_aggregerat);
                        ChartService.SetSkogData(response.data.volym.total, response.data.volym.avverkningsbar_alder, response.data.volym.avverkningsbar_reglerad_kvar);

                    },
                    function(response) {

                    },
                    rawData
                );
                delete vm.prognosTimeout;

            }, 300);
        }

        function updateForestValue(aggregatedResult) {

            if (resultat_aggregerat != null && typeof resultat_aggregerat !== 'undefined' && vm.computation.returns > 0) {
                console.log("update: " + resultat_aggregerat);
                var num = resultat_aggregerat / (vm.computation.returns / 100);
                console.log(num);


                if (num >= 0) {
                    vm.computation.forestValue = Math.round(num / (vm.intaekter.avverkning || []).length);
                    console.log("after round: " + vm.computation.forestValue + " " + vm.prices.slutavverkning);
                } else {
                    vm.computation.forestValue = 0;
                }
            }

        }

        function doUpdateSum() { //newValues, oldValues, scope

            vm.sum = new Array(vm.intaekter.avverkning.length);

            // intäkter
            for (var i = 0; i < vm.intaekter.avverkning.length; i++) {
                vm.sum[i] = (vm.sum[i] || 0) + vm.intaekter.avverkning[i];
            }
            vm.sum[0] = vm.sum[0] + vm.intaekter.gallring;


            // kostnader
            for (var j = 0; j < vm.kostnader.aterbeskogning.length; j++) {
                vm.sum[j] = (vm.sum[j] || 0) - vm.kostnader.aterbeskogning[j] - vm.kostnader.lan;
            }
            vm.sum[0] = vm.sum[0] - vm.kostnader.rojning;

        }


    }

})();

(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .controller('WorkspaceController', WorkspaceController);

    function AppCtrl($scope) {
        $scope.currentNavItem = 'page1';
    }

    /** @ngInject */
    function WorkspaceController($scope, $state, $stateParams, $uibModal, $sbpModal, $element, EndpointService, ChartService, CurrentSessionService, notify, $timeout, $window, $document, $log) { //$scope $http

        var vm = this;

        vm.hasDoneFastighet = false;
        vm.hasDoneParams = false;

        vm.hasDoneRaknaUpp = false;
        vm.hasDoneSendParams = false;
        vm.hasDoneGetPrognosFirstTime = false;

        vm.year = new Date().getFullYear();
        vm.raknaupp = false;
        vm.open = openSBP;
        vm.befintligt_innehav = true;

        vm.form = {
            forvarvstyp: "BI",
            pantbrev:0,
            lan:0,
            raenta:0,
            //avkastning:null,
            intaekt: {
                virkespris_slutavverkning:null, 
                virkespris_gallring:null
            },
            kostnad: {
                rojning:null, 
                aterbeskogning:null
            }
        }

        vm.prognosform = CurrentSessionService.GetPrognosParams() || {
            avverkning: 0,
            rojning: [],
            gallring: []
        }

        vm.intaekter = {
            avverkning: [],
            avverkningTot: 0,
            gallring: 0
        }

        vm.kostnader = {
            aterbeskogning: [],
            aterbeskogningTot: 0,
            lan: 0,
            rojning: 0
        }

        vm.marknadspriser = null;
        
        vm.berakningsformer = [['Ingen', 0], ['Belåning', 1], ['Avkastning', 2]];
        vm.berakningsform = 0;


        var resultat_aggregerat;



        var aldersdata = [
            'Kalmark',
            '0 - 9',
            '10 - 19',
            '20 - 29',
            '30 - 39',
            '40 - 49',
            '50 - 59',
            '60 - 69',
            '70 - 79',
            '80 - 89',
            '90 - 99',
            '100 - 109',
            '110 - 119',
            '120+',
            'Lågproduktiv skog'
        ];



        var skogsbruksplaner = {
            kommun: null,
            current: null,
            original: null,
            uppraeknad: null,
            totVol: 0
        }

        vm.showNavigation = true;
        vm.showSbp = false;
        
        $scope.$watch(
                "skogsbruksplaner.kommun", 
            doSetDefaultParamsWatch);

        $scope.$watch(
                "vm.berakningsform", 
            onBerakningsformChange);

        $scope.$watch(
                "vm.befintligt_innehav", 
            onInnehavChange);

        $scope.$watch(
                "vm.form.forvarvstyp", 
            onForvarvChange);

        $scope.$watch(
                "vm.avkastning", 
            doUpdateAvkastning);

        $scope.$watch(
                "vm.raknaupp", 
            doChangeSkogsbruksplan);


        $scope.$watchGroup([
                'vm.form.pantbrev', 
                'vm.form.lan',
                'vm.form.raenta',
                'vm.form.intaekt.virkespris_slutavverkning',
                'vm.form.intaekt.virkespris_gallring',
                'vm.form.kostnad.rojning',
                'vm.form.kostnad.aterbeskogning'
            ], doSendParamsUpdatePrognos);

        $scope.$watchGroup([
                'vm.form.pantbrev', 
                'vm.form.lan',
                'vm.form.raenta',
            ], doShowLan);


        $scope.$watchGroup([
                'vm.prognosform.avverkning', 
                'vm.prognosform.gallring',
                'vm.prognosform.rojning'
            ], doUpdatePrognos);

        

        $scope.$watchGroup([
                'vm.intaekter', 
                'vm.kostnader'
            ], doUpdateSum);

        


        var initializing = true


        function doSetDefaultParamsWatch(newValue, oldValue) {
            if (!initializing && !vm.hasDoneParams && vm.hasDoneFastighet) {
                setDefaultParams();
            }
        }

        function setDefaultParams(callback) {
            EndpointService.GetMarknadspriser(function (response) {

                var done = false;

                for (var i = 0; i < response.data.length; i++) {
                    if (response.data[i].kommun == skogsbruksplaner.kommun) {
                        vm.form.intaekt.virkespris_slutavverkning = response.data[i].slutavverkning;
                        vm.form.intaekt.virkespris_gallring = response.data[i].gallring;
                        vm.form.kostnad.rojning = response.data[i].rojning;
                        vm.form.kostnad.aterbeskogning = response.data[i].aterbeskogning;
                        done = true;
                        break;
                    }
                }

                if (!done) {
                    vm.form.intaekt.virkespris_slutavverkning = 0;
                    vm.form.intaekt.virkespris_gallring = 0;
                    vm.form.kostnad.rojning = 0;
                    vm.form.kostnad.aterbeskogning = 0;
                }

                vm.isloading = true;
                EndpointService.SendParams(
                    function(response) {  
                        if (callback) {
                            callback();
                        }
                    }, 
                    handleError,
                    vm.form
                );
            }, handleError);
        }

        var savedBerakning = {
            lan:null,
            raenta:null,
            pantbrev:null,
            avkastning:null,
            avverkning: null,
        }

        function onBerakningsformChange(newValue, oldValue) {

            if (oldValue == 1) {
                savedBerakning.lan = vm.form.lan;
                savedBerakning.raenta = vm.form.raenta;
                savedBerakning.pantbrev = vm.form.pantbrev;
            }

            if (oldValue == 2) {
                savedBerakning.avkastning = vm.avkastning;
                vm.prognosform.avverkning = savedBerakning.avverkning || 0;
            } else {
                savedBerakning.avverkning = null;
            }

            if (newValue == 0 ) {
                vm.form.lan = 0;
                vm.form.raenta = 0;
                vm.form.pantbrev = 0;
                vm.avkastning = 0;
            }

            if (newValue == 1) {
                vm.form.lan = savedBerakning.lan || vm.form.lan;
                vm.form.raenta = savedBerakning.raenta || vm.form.raenta;
                vm.form.pantbrev = savedBerakning.raenta || vm.form.laraentan;
                vm.avkastning = null;
            }

            if (newValue == 2) {
                vm.avkastning = savedBerakning.avkastning || vm.avkastning;
                vm.form.lan = 0;
                vm.form.raenta = 0;
                vm.form.pantbrev = 0;
                savedBerakning.avverkning = vm.prognosform.avverkning;
                vm.prognosform.avverkning = 2;
            }
            
        }

        function onInnehavChange(newValue, oldValue) {
            if (newValue) {
                vm.form.forvarvstyp = "BI";
            }
            else {
                vm.form.forvarvstyp = "KO";
            }
            
        }


        function onForvarvChange(newValue, oldValue) {
            if (newValue == "BI") {
                vm.befintligt_innehav = true;
            } else {
                vm.befintligt_innehav = false;
            }
            doSendParamsUpdatePrognos();
        }

        function doUpdateSum() { //newValues, oldValues, scope
            if (!initializing) {
                vm.sum = new Array(vm.intaekter.avverkning.length);

                // intäkter
                for (var i = 0; i < vm.intaekter.avverkning.length; i++) {
                    vm.sum[i] = (vm.sum[i] || 0) + vm.intaekter.avverkning[i];
                }
                vm.sum[0] = vm.sum[0] + vm.intaekter.gallring;


                // kostnader
                for (var j = 0; j < vm.kostnader.aterbeskogning.length; j++) {
                    vm.sum[j] = (vm.sum[j] || 0) - vm.kostnader.aterbeskogning[j] - vm.kostnader.lan;
                }
                vm.sum[0] = vm.sum[0] - vm.kostnader.rojning;
            }
        }
        
        function doSendParamsUpdatePrognos() { //newValues, oldValues, scope
            if (!initializing && vm.hasDoneFastighet && vm.hasDoneParams) {
                if (vm.viewForm.$valid) {
                    vm.isloading = true;
                    EndpointService.SendParams(
                        function(response) {  
                            getPrognos();
                        }, 
                        handleError,
                        vm.form
                    );
                }
              }
        }

        

        function doUpdatePrognos() { //newValues, oldValues, scope
            if (!initializing && vm.hasDoneFastighet && vm.hasDoneParams) {
                if (vm.viewForm.$valid) {
                    getPrognos();
                }
            }
        }

        function doUpdateAvkastning() { //newValue, oldValue
            if (!initializing) {
                if (resultat_aggregerat != null && typeof resultat_aggregerat !== 'undefined' && vm.avkastning > 0) {
                    var num = resultat_aggregerat / (vm.avkastning / 100);
                    if (num >= 0) {
                        vm.fastighetsvarde = Math.round(num / (vm.intaekter.avverkning || []).length);
                    } else {
                        vm.fastighetsvarde = 0;
                    }
                } 
            }
        }

        
        function doChangeSkogsbruksplan(newValue, oldValue) {
            if (!initializing && vm.hasDoneFastighet){
                EndpointService.SetUppraeknad(
                    function (response) {
                        if (newValue) {
                            skogsbruksplaner.current = skogsbruksplaner.uppraeknad; 
                        } else {
                            skogsbruksplaner.current = skogsbruksplaner.original;

                        }

                        if (skogsbruksplaner.current != null) {
                            ChartService.SetSbpData(skogsbruksplaner.current.data);
                        } else {
                            EndpointService.GetSkogsbruksplan(
                                function(response) {
                                    handleSbpResponse(response);
                                    ChartService.SetSbpData(skogsbruksplaner.current.data);
                                }, 
                                handleError
                            );
                        }

                        doUpdatePrognos();
                    }, 
                    handleError, 
                    newValue
                )
                
            }
        }        

        function doShowLan(newValues, oldValues, scope) {
            if (initializing) {
                for (var i in newValues) {
                    if (newValues[i] || 0 > 0) {
                        vm.berakningsform = 1;
                        break;
                    } 
                }
            }
        }

        $scope.$on('$viewContentLoaded', function(){
            console.log("View content loaded!");
            ChartService.SetSbpChart($document[0].getElementById('chart_sbp'));
            ChartService.SetResultatChart($document[0].getElementById('chart_resultat'));
            ChartService.SetSkogChart($document[0].getElementById('chart_skog'));
            initWorkspace(syncWorkspace);
        });
        

        angular.element($window).bind('resize', function(){
            ChartService.DrawAll();

            // manuall $digest required as resize event
            // is outside of angular
            $scope.$digest();
        });


        var isOpeningSBP = false;
        var isOpeningNavigation = false;

        vm.sbpanimated = function (event) {
            if (isOpeningNavigation) {
                vm.showNavigation = true;
                $scope.$apply();
            }
        };
        vm.navigationanimated = function (event) {
            if (isOpeningSBP) {
                var elementTo = angular.element($document[0].getElementById('sbpinject'));
                var modalInstance = $sbpModal.open({
                    //windowTemplateUrl: 'app/workspace/modalWindowTemplate.html',
                    templateUrl: 'app/views/sbp/sbp.html',
                    css: 'app/views/sbp/sbp.css',
                    controller: 'SBPController',
                    controllerAs: 'vm',
                    bindToController: true,
                    appendTo: elementTo,
                    //backdrop  : 'static',
                    //keyboard  : false,
                    resolve: {
                        aldersdata: function() {
                            return aldersdata;
                        },
                        sbp: function() {
                            return skogsbruksplaner.original;
                        }
                    }
                });

                modalInstance.rendered.then(function () {
                    vm.showSbp = true;
                    //$scope.$apply();
                });

                modalInstance.result.then(modalOk, modalDismiss);
                

            }
        };


        function modalOk(result) {
            if (result.isSuccess) {
                isOpeningSBP = false;
                isOpeningNavigation = true;
                vm.showSbp = false;
                if (!vm.hasDoneFastighet) {
                    skogsbruksplaner.kommun = result.sbp.kommun;
                    skogsbruksplaner.original = result.sbp;
                    skogsbruksplaner.current = result.sbp;
                }
                vm.hasDoneFastighet = true;
                ChartService.SetSbpData(skogsbruksplaner.current.data);
                syncWorkspace();
            }
            
            
        }

        function modalDismiss(result) {
            isOpeningSBP = false;
            isOpeningNavigation = true;
            vm.showSbp = false;
        }
        

        function openSBP(size) {
            isOpeningSBP = true;
            isOpeningNavigation = false;
            vm.showNavigation = false;
        }

        
        

        function initWorkspace(callback) {
            var initFastighet = false;
            var initParams = false;


            if (!vm.hasDoneFastighet) {
                vm.isloading = true;
                EndpointService.GetSkogsbruksplan(
                    function(response) {
                        handleSbpResponse(response);

                        vm.hasDoneFastighet = true;
                        initFastighet = true;
                        initWorkspaceMiddleCallback(callback);
                    }, 
                    function() {
                        initFastighet = true;
                        initWorkspaceMiddleCallback(callback);
                    }
                );
            }

            if (!vm.hasDoneParams) {
                vm.isloading = true;
                EndpointService.GetParams(
                    function(response) {

                        vm.form.forvarvstyp = response.data.forvarvstyp;
                        vm.form.lan = response.data.lan;
                        vm.form.pantbrev = response.data.pantbrev;
                        vm.form.raenta = response.data.raenta;
                        vm.form.intaekt.virkespris_slutavverkning = response.data.intaekt.virkespris_slutavverkning;
                        vm.form.intaekt.virkespris_gallring = response.data.intaekt.virkespris_gallring;
                        vm.form.kostnad.rojning = response.data.kostnad.rojning;
                        vm.form.kostnad.aterbeskogning = response.data.kostnad.aterbeskogning;

                        vm.hasDoneParams = true;
                        initParams = true;
                        initWorkspaceMiddleCallback(callback);
                    },
                    function(response) {
                        initParams = true;
                        initWorkspaceMiddleCallback(callback);
                    }
                );
            }

            EndpointService.GetMarknadspriser(
                function(response) {
                    vm.marknadspriser = response.data;
                    initWorkspaceMiddleCallback(callback);
                },
                function(response) {
                    vm.marknadspriser = false
                    initWorkspaceMiddleCallback(callback);
                }
            );


            function initWorkspaceMiddleCallback(callback) {
                if (initFastighet && initParams && (vm.marknadspriser != null)) {
                    vm.isloading = false;
                    callback();
                }
            }
            
        }

        function syncWorkspace() {
            if (vm.hasDoneFastighet) {
                ChartService.SetSbpData(skogsbruksplaner.current.data);
            }

            if (vm.hasDoneFastighet && !vm.hasDoneParams) {
                setDefaultParams(function () {
                    vm.hasDoneParams = true;
                    getPrognos(function () {
                        initializing = false;
                    })
                });
            } else if (vm.hasDoneFastighet && vm.hasDoneParams) {
                getPrognos(function () {
                    initializing = false;
                });
            } else {
                initializing = false;
            }
        }

        function syncWorkspace_bak() {
            if (vm.viewForm.$valid) {
                vm.isloading = true;
                EndpointService.SendParams(
                    function(response) {  
                        getPrognos();
                    }, 
                    handleError,
                    vm.form
                );
            }
        }


        function handleError(response) {
            vm.isloading = false;
            notify(response.statusText);
            console.log(response);
        }

        function getPrognos(callback) {
            vm.isloading = true;
            EndpointService.GetPrognos(
                function (response) {
                    vm.isloading = false;
                    resultat_aggregerat = response.data.resultat_aggregerat[response.data.resultat_aggregerat.length-1];

                    vm.intaekter = {
                        avverkning: response.data.intaekter.avverkning,
                        avverkningTot: 0,
                        gallring: response.data.intaekter.gallring
                    }

                    

                    vm.kostnader = {
                        aterbeskogning: response.data.kostnader.aterbeskogning,
                        aterbeskogningTot: 0,
                        lan: response.data.kostnader.lan,
                        rojning: response.data.kostnader.rojning
                    }

                    for (var i = vm.intaekter.avverkning.length - 1; i >= 0; i--) {
                        vm.intaekter.avverkningTot += vm.intaekter.avverkning[i];
                        vm.kostnader.aterbeskogningTot += vm.kostnader.aterbeskogning[i];
                    }

                    ChartService.SetResultatData(response.data.resultat, response.data.pantbrevskostnad, response.data.resultat_aggregerat);
                    ChartService.SetSkogData(response.data.volym.total, response.data.volym.avverkningsbar_alder, response.data.volym.avverkningsbar_reglerad_kvar);
                    doUpdateAvkastning();

                    if (callback) {
                        callback();
                    }
                }, 
                handleError, 
                vm.prognosform
            )
        }


        function getTotskogsvolym() {
            var totalt = 0;
            for (var i = skogsbruksplaner.current.data.length - 1; i >= 0; i--) {
                totalt = totalt + skogsbruksplaner.current.data[i].m3sk;
            }
            vm.totSkogsvolym = totalt;
        }


        function handleSbpResponse(response) {
            skogsbruksplaner.kommun = response.data.kommun;
            skogsbruksplaner.original = response.data.grundplan;
            skogsbruksplaner.uppraeknad = response.data.uppraeknad;

            if (response.data.aktiv == "grund") {
                skogsbruksplaner.current = skogsbruksplaner.original;    
            } else {
                skogsbruksplaner.current = skogsbruksplaner.uppraeknad;
                vm.raknaupp = true;
            }
            
        }

    }

})();

(function() {
	'use strict';

	angular
	.module('skogscalcPublik')
	.controller('StartController', StartController);

	/** @ngInject */
	function StartController(EndpointService, $stateParams, $location, AuthenticationService, $rootScope, $log, $state, notify, $element, $sbpModal, $document, $cookies) {

		var vm = this;

        var aldersdata = [
            'Kalmark',
            '0 - 9',
            '10 - 19',
            '20 - 29',
            '30 - 39',
            '40 - 49',
            '50 - 59',
            '60 - 69',
            '70 - 79',
            '80 - 89',
            '90 - 99',
            '100 - 109',
            '110 - 119',
            '120+',
            'Lågproduktiv skog'
        ];

        var skogsbruksplaner = {
            kommun: null,
            current: null,
            original: null,
            uppraeknad: null,
            totVol: 0
        };

        if($cookies.get('sbp')) {
            $cookies.remove('sbp');
        }

        var elementTo = angular.element($document[0].getElementById('sbpinject'));

        $sbpModal.open({
            templateUrl: 'app/views/sbp/sbp.html',
            css: 'app/views/sbp/sbp.css',
            controller: 'SBPController',
            controllerAs: 'vm',
            bindToController: true,
            appendTo: elementTo,
            resolve: {
                aldersdata: function() {
                    return aldersdata;
                },
                sbp: function() {
                    return skogsbruksplaner.original;
                }
            }
        });

		/* wat? */
		vm.init = initialize;

		function initialize() {
			$state.go('main.init');
		}
	}
})();

(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .controller('SBPController', SBPController);

    /** @ngInject */
    function SBPController($document, $state, CurrentSessionService, $scope, $sbpModalInstance, EndpointService, notify, $parse, aldersdata, sbp, $cookies) {

        var vm = this;

        vm.isLoading = false;
        vm.aldersdata = aldersdata;
        vm.hasDoneFastighet = false;
        vm.currentYear = (new Date()).getFullYear();
        vm.SBPName = "";

        vm.contains = function(kommun) {

            for (var i = vm.kommuner.length - 1; i >= 0; i--) {
                if (vm.kommuner[i].namn == kommun) {
                    return true;
                }
            }
            return false;
        }

        vm.form = {
            kommun: vm.kommun,
            uppraeknad: false,
            datumGjord: vm.datumGjord,
            bonitet: vm.bonitet,
            data: [
                    {aldersgrupp:0, hektar:null, m3sk:0},
                    {aldersgrupp:1, hektar:null, m3sk:null},
                    {aldersgrupp:2, hektar:null, m3sk:null},
                    {aldersgrupp:3, hektar:null, m3sk:null},
                    {aldersgrupp:4, hektar:null, m3sk:null},
                    {aldersgrupp:5, hektar:null, m3sk:null},
                    {aldersgrupp:6, hektar:null, m3sk:null},
                    {aldersgrupp:7, hektar:null, m3sk:null},
                    {aldersgrupp:8, hektar:null, m3sk:null},
                    {aldersgrupp:9, hektar:null, m3sk:null},
                    {aldersgrupp:10, hektar:null, m3sk:null},
                    {aldersgrupp:11, hektar:null, m3sk:null},
                    {aldersgrupp:12, hektar:null, m3sk:null},
                    {aldersgrupp:13, hektar:null, m3sk:null},
                    {aldersgrupp:14, hektar:null, m3sk:null}
                ]

        }

        vm.sumAreal = 0;
        vm.sumVolym = 0;

        $scope.$watch("vm.SBPName", function() {
            CurrentSessionService.setSBPName(vm.SBPName);
            $cookies.put('sbpname', vm.SBPName);
        });

        for(var key in vm.form.data) {
            if(vm.form.data.hasOwnProperty(key)) {
                $scope.$watch("vm.form.data['" + key + "'].hektar", watchChangeAreal);
                $scope.$watch("vm.form.data['" + key + "'].m3sk", watchChangeVolym);
                $scope.$watch("vm.form.data['" + key + "'].hektar", checkAlderErrors);
                $scope.$watch("vm.form.data['" + key + "'].m3sk", checkAlderErrors);
            }
        }

        $scope.$watch("vm.frotrad.m3sk", watchChangeVolym);
        $scope.$watch("vm.frotrad.hektar", checkAlderErrors);
        $scope.$watch("vm.frotrad.m3sk", checkAlderErrors);
        //$scope.$watchGroup("vm.sbpForm.$error.min", checkErrors);

        vm.aldersdataValid = true;

        function checkAlderErrors(newValue, oldValue) {

            if(vm.sbpForm.$error.number || vm.sbpForm.$error.min) {
                vm.aldersdataValid = false;
            } else {
                vm.aldersdataValid = true;
            }

        }

        function watchChangeAreal(newValue, oldValue) {

            if(oldValue !== null && oldValue !== undefined) {
                vm.sumAreal -= oldValue;
            }
            if(newValue !== null && newValue !== undefined) {
                vm.sumAreal += newValue;
            }
            
        }

        function watchChangeVolym(newValue, oldValue) {

            if(oldValue !== null && oldValue !== undefined) {
                vm.sumVolym -= oldValue;
            }
            if(newValue !== null && newValue !== undefined) {
                vm.sumVolym += newValue;
            }
        }


        EndpointService.GetKommuner(function(response) {
            vm.kommuner = response;
        }, function(response) {
            notify(response.statusText);
        });

        function setDataFieldError(fieldNr, errorTextArr) {
            /*
            for (var i = 0; i < errorTextArr.length; i++) {
                var fieldName = 'hektar';
                var formFieldName = 'data-'+i;
                var partialForm = vm.sbpForm[formFieldName];

                var serverMessage = $parse('vm.sbpForm.'+formFieldName+'.'+fieldName+'.$error.serverMessage');
                vm.sbpForm.$setValidity("serverMessage", false, partialForm.hektar);
                serverMessage.assign($scope, errorText.hektar[0]);
            }
            */
        }

        function setFieldError(fieldName, errorText) {
            var field = vm.sbpForm[fieldName];

            if (typeof field  !== 'undefined') {
                var serverMessage = $parse('vm.sbpForm.'+fieldName+'.$error.serverMessage');
                vm.sbpForm.$setValidity("serverMessage", false, field);
                serverMessage.assign($scope, errorText);
            }
        }

        function setErrors(errors) {
            vm.sbpForm;
            for (var errorProperty in errors) {
                if (errors.hasOwnProperty(errorProperty)) {
                    if (errorProperty !== 'data') {
                        setFieldError(errorProperty, errors[errorProperty]);
                    } else {
                        setDataFieldError(errorProperty, errors[errorProperty]);
                    }
                    
                }
            }

        }

        vm.submit = function () {

            vm.submitted = true;

            if (vm.sbpForm.$error.serverMessage) {
                for(var i in vm.sbpForm.$error.serverMessage) {
                    vm.sbpForm.$setValidity("serverMessage", true, vm.sbpForm.$error.serverMessage[i]);
                }
                
            }
            
            if (vm.checkValid()) {

                addFrotrad();

                $cookies.put('sbp', JSON.stringify(vm.form));

                CurrentSessionService.SetSkogsbruksplan(vm.form, null, "grund");

                $state.go('main.workspace');

            }
        };

        vm.cancel = function () {
            $sbpModalInstance.dismiss('cancel');
        };

        vm.checkValid = function () {
            var isValid = vm.sbpForm.$valid;
            if (!isValid) {
                notify("Formulär inte korrekt ifyllt.");
                console.log(vm.sbpForm)

                vm.sbpForm.kommun.$setTouched();
                vm.sbpForm.datumGjord.$setTouched();
                vm.sbpForm.bonitet.$setTouched();

                vm.submitted = false;
            }
            return isValid;
        }


        function addFrotrad() {
            if (vm.frotrad) {
                vm.form.data[13].hektar = vm.form.data[13].hektar + (vm.frotrad.hektar || 0);
                vm.form.data[13].m3sk = vm.form.data[13].m3sk + (vm.frotrad.m3sk || 0);    
            }
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .controller('MainController', MainController);

    /** @ngInject */
    function MainController() { //$scope $http
        //var vm = this;
        
    }
})();

(function() {
	'use strict';

	angular
	.module('skogscalcPublik')
	.controller('PrintController', PrintController);

	/** @ngInject */
	function PrintController($scope, EndpointService, ChartService, CurrentSessionService, $document, $timeout, $window, $state) {
		var vm = this;

        
		var skogsbruksplan = CurrentSessionService.GetSkogsbruksplan();
        var prognos = CurrentSessionService.GetPrognos();
        var params = CurrentSessionService.GetParams();

        if (!skogsbruksplan || !prognos || !params) {
        	$state.go('main.workspace');
        }

        vm.skogsbruksplan = skogsbruksplan;
        vm.aldersdata = ChartService.GetAldersdata();

        vm.params = params;

		vm.year = new Date().getFullYear();
        vm.intaekter = prognos.intaekter;
        vm.kostnader = prognos.kostnader;


        vm.sum = new Array(vm.intaekter.avverkning.length);

        // intäkter
        for (var i = 0; i < vm.intaekter.avverkning.length; i++) {
            vm.sum[i] = (vm.sum[i] || 0) + vm.intaekter.avverkning[i];
        }
        vm.sum[0] = vm.sum[0] + vm.intaekter.gallring;


        // kostnader
        for (var j = 0; j < vm.kostnader.aterbeskogning.length; j++) {
            vm.sum[j] = (vm.sum[j] || 0) - vm.kostnader.aterbeskogning[j] - vm.kostnader.lan;
        }
        vm.sum[0] = vm.sum[0] - vm.kostnader.rojning;

        vm.intaekter.avverkningTot = 0;
        vm.kostnader.aterbeskogningTot = 0;

        for (var i = vm.intaekter.avverkning.length - 1; i >= 0; i--) {
            vm.intaekter.avverkningTot += vm.intaekter.avverkning[i];
            vm.kostnader.aterbeskogningTot += vm.kostnader.aterbeskogning[i];
        }


		$scope.$on('$viewContentLoaded', function(){
            ChartService.SetSbpChart($document[0].getElementById('chart_sbp'));
            ChartService.SetResultatChart($document[0].getElementById('chart_resultat'));
            ChartService.SetSkogChart($document[0].getElementById('chart_skog'));


            ChartService.ToImagesCallback(function () {
            	$timeout($window.print, 0);
            })


            ChartService.SetSbpData(skogsbruksplan.data);

            
            ChartService.SetResultatData(prognos.resultat, prognos.pantbrevskostnad, prognos.resultat_aggregerat);
            ChartService.SetSkogData(prognos.volym.total, prognos.volym.avverkningsbar_alder, prognos.volym.avverkningsbar_reglerad_kvar);
        });
				

	}
})();

(function () {
    'use strict';
 
    angular
        .module('skogscalcPublik')
        .controller('LoginController', LoginController);
 
    //LoginController.$inject = ['$location', 'AuthenticationService', 'notify'];
    /** @ngInject */
    function LoginController($location, AuthenticationService, notify, $state, $stateParams) {
        var vm = this;
 
        vm.login = login;
        vm.username = "";
        vm.password = "";

        (function initController() {
            // reset login status
            AuthenticationService.ClearCredentials();
        })();

        function login() {
            vm.dataLoading = true;
            AuthenticationService.Login(vm.username, vm.password, function (response) {
                if (response.success) {
                    AuthenticationService.SetCredentials(response.data.token, vm.username);
                    $state;
                    $stateParams;
                    var next = $location.search().next
                    if (typeof next !== 'undefined') {
                        var states = $state.get();
                        var stateName = null;
                        for (var i = states.length - 1; i >= 0; i--) {
                            if (states[i].url == next) {
                                stateName = states[i].name;
                                break;
                            }
                        }
                        if (stateName != null) {
                            $state.go(stateName);
                            
                        } else {
                            $state.go("start");    
                        }
                    } else {
                        $state.go("start");
                    }
                    //$location.path('/start');
                } else {
                    notify(response.data);
                    vm.dataLoading = false;
                }
            });
        }
    }
 
})();
(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .controller('InitController', InitController);

    /** @ngInject */
    function InitController($scope, $state, $stateParams, notify, $element, EndpointService, $window, $document, $log) { //$scope $http
        var vm = this;

        EndpointService.InitKalkyl(function () {
            $state.go('main.workspace');
        }, function(response) {
            notify(response.statusText);
        })
        

    }

})();

(function () {
    'use strict';
 
    angular
        .module('skogscalcPublik')
        .factory('EndpointService', EndpointService);
 
    /** @ngInject */
    function EndpointService($timeout, $filter, $q, localStorageService, $http, CurrentSessionService) { //$timeout, $filter, $q
        
        var service = {};
        
        service.GetKommuner = GetKommuner;
        service.InitKalkyl = InitKalkyl;
        service.GetKalkyler = GetKalkyler;
        service.PutKalkyl = PutKalkyl;
        service.SendSkogsbruksplan = SendSkogsbruksplan;
        service.GetSkogsbruksplan = GetSkogsbruksplan;
        service.SetUppraeknad = SetUppraeknad;
        service.SendParams = SendParams;
        service.GetPrognos = GetPrognos;
        service.getPrognos = getPrognos;
        service.GetParams = GetParams;
        service.GetMarknadspriser = GetMarknadspriser;

        service.getMarketPrices = getMarketPrices;
        
        
        function InitKalkyl(success, fail) {
            $http({
                url: "/api/kalkyl/",
                method: "POST"
            }).then(function (response) {
                CurrentSessionService.Reset();
                success(response);
            }, fail);
        }

        function GetKalkyler(success, fail) {
            $http({
                url: "/api/kalkyl/",
                method: "Get"
            }).then(success, fail);
        }

        function PutKalkyl(successCallback, failCallback, index) {
            if (index > 0) {
                $http({
                    url: "/api/kalkyl/",
                    method: "PUT",
                    data: {
                        aktiv: index
                    }
                }).then(function (response) {
                    CurrentSessionService.Reset();
                    successCallback(response);
                }, failCallback);
            } else {
                if (failCallback) {
                    failCallback({message:"index must be greater than 1."})    
                }
            }
            
        }



        function GetKommuner(success, fail) {
            var key = 'kommuner';
            //localStorageService.remove(key);
            var kommuner = localStorageService.get(key);
            if (true) {

                $http({
                    url: "/api/kommuner/",
                    method: "GET"
                }).then(function(Response) {
                    localStorageService.set(key, Response.data);
                    success(Response.data)
                }, fail);

            } else {
                return success(kommuner);
            }
        }

        function SendSkogsbruksplan(successCallback, failCallback, data) {
            CurrentSessionService.SetSkogsbruksplan(data, null, "grund");
            /*
            $http({
                url: "/api/skogsbruksplan/",
                method: "POST",
                data: data
            }).then(successCallback, failCallback);
            */

        }

        function GetSkogsbruksplan(successCallback, failCallback) {
            $http({
                url: "/api/skogsbruksplan/",
                method: "GET"
            }).then(function (response) {
                response.data.grundplan.kommun = response.data.kommun;
                response.data.uppraeknad.kommun = response.data.kommun;

                response.data.grundplan.bonitet = parseInt(response.data.bonitet);
                response.data.uppraeknad.bonitet = parseInt(response.data.bonitet);

                response.data.grundplan.datumGjord = new Date(response.data.grundplan.datumGjord).getFullYear();
                response.data.uppraeknad.datumGjord = new Date(response.data.uppraeknad.datumGjord).getFullYear();
                
                CurrentSessionService.SetSkogsbruksplan(response.data.grundplan, response.data.uppraeknad, response.data.aktiv);

                if (successCallback) {
                    successCallback(response);
                }
            }, failCallback);
        }

        function SetUppraeknad(successCallback, failCallback, shouldBeUppraeknad) {
            var data = 'grund';

            if (shouldBeUppraeknad) {
                data = 'uppraeknad';
            } 

            CurrentSessionService.SetSkogsbruksplanAktiv(data);

            $http({
                url: "/api/skogsbruksplan/",
                method: "PUT",
                data: {
                    aktiv: data
                }
            }).then(successCallback, failCallback);
        }

        function SendParams(successCallback, failCallback, data) {
            CurrentSessionService.SetParams(data);
            $http({
                url: "/api/parametrar/",
                method: "POST",
                data: data
            }).then(successCallback, failCallback);
        }

        function GetParams(successCallback, failCallback) {
            $http({
                url: "/api/parametrar/",
                method: "GET"
            }).then(function (response) {
                CurrentSessionService.SetParams(response.data);
                successCallback(response);
            }, failCallback);
        }

        function GetPrognos(successCallback, failCallback, data) {
            CurrentSessionService.SetPrognosParams(data);
            $http({
                url: "/api/prognos/",
                method: "POST",
                data: data
            }).then(function (response) {
                CurrentSessionService.SetPrognos(response.data);
                successCallback(response);
            }, failCallback);
        }

        function getPrognos(successCallback, failCallback, data) {
            CurrentSessionService.SetPrognosParams(data);
            $http({
                url: "/api/prognos/",
                method: "POST",
                data: data
            }).then(function (response) {
                CurrentSessionService.SetPrognos(response.data);
                successCallback(response);
            }, failCallback);
        }

        function GetMarknadspriser(successCallback, failCallback) {

            $http({
                url: "/api/marknadspris/",
                method: "GET"
            }).then(function(response) {
                var newData = new Array(response.length);
                for (var i = 0; i < response.data.length; i++) {
                    newData[i] = {
                        kommun: response.data[i].kommun,
                        slutavverkning: response.data[i].virkespris_avverkning - response.data[i].kostnad_avverkning,
                        gallring: response.data[i].virkespris_gallring - response.data[i].kostnad_gallring,
                        rojning: response.data[i].rojning,
                        aterbeskogning: response.data[i].aterbeskogning
                    }
                }
                response.data = newData;
                successCallback(response)
                
            }, failCallback);

        }

        function getMarketPrices(successCallback, failCallback) {

            var kommun = CurrentSessionService.GetSkogsbruksplan().kommun;

            $http({
                url: "/api/marknadspris/" + kommun + "/",
                method: "GET"
            }).then(function(response) {

                var data = {
                    slutavverkning: response.data.virkespris_avverkning - response.data.kostnad_avverkning,
                    gallring: response.data.virkespris_gallring - response.data.kostnad_gallring,
                    rojning: response.data.rojning,
                    aterbeskogning: response.data.aterbeskogning
                }
                response.data = data;
                successCallback(response);
            }, failCallback);

        }

        function handleSuccess(res) {
            return res.data;
        }
 
        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }



        /*
        function GetAll() {
            var deferred = $q.defer();
            deferred.resolve(getUsers());
            return deferred.promise;
        }
 
        function GetById(id) {
            var deferred = $q.defer();
            var filtered = $filter('filter')(getUsers(), { id: id });
            var user = filtered.length ? filtered[0] : null;
            deferred.resolve(user);
            return deferred.promise;
        }
 
        function GetByUsername(username) {
            var deferred = $q.defer();
            var filtered = $filter('filter')(getUsers(), { username: username });
            var user = filtered.length ? filtered[0] : null;
            deferred.resolve(user);
            return deferred.promise;
        }
 
        function Create(user) {
            var deferred = $q.defer();
 
            // simulate api call with $timeout
            $timeout(function () {
                GetByUsername(user.username)
                    .then(function (duplicateUser) {
                        if (duplicateUser !== null) {
                            deferred.resolve({ success: false, message: 'Username "' + user.username + '" is already taken' });
                        } else {
                            var users = getUsers();
 
                            // assign id
                            var lastUser = users[users.length - 1] || { id: 0 };
                            user.id = lastUser.id + 1;
 
                            // save to local storage
                            users.push(user);
                            setUsers(users);
 
                            deferred.resolve({ success: true });
                        }
                    });
            }, 1000);
 
            return deferred.promise;
        }
 
        function Update(user) {
            var deferred = $q.defer();
 
            var users = getUsers();
            for (var i = 0; i < users.length; i++) {
                if (users[i].id === user.id) {
                    users[i] = user;
                    break;
                }
            }
            setUsers(users);
            deferred.resolve();
 
            return deferred.promise;
        }
 
        function Delete(id) {
            var deferred = $q.defer();
 
            var users = getUsers();
            for (var i = 0; i < users.length; i++) {
                var user = users[i];
                if (user.id === id) {
                    users.splice(i, 1);
                    break;
                }
            }
            setUsers(users);
            deferred.resolve();
 
            return deferred.promise;
        }
 
        // private functions
 
        function getUsers() {
            if(!localStorage.users){
                localStorage.users = JSON.stringify([]);
            }
 
            return JSON.parse(localStorage.users);
        }
 
        function setUsers(users) {
            localStorage.users = JSON.stringify(users);
        }
        */
        return service;
    }
})();
(function () {
    'use strict';
    /*
    angular
        .module('skogscalcPublik')
        .factory('UserService', UserService);
 
    UserService.$inject = ['$http'];
    function UserService($http) {
        var service = {};
 
        service.GetAll = GetAll;
        service.GetById = GetById;
        service.GetByUsername = GetByUsername;
        service.Create = Create;
        service.Update = Update;
        service.Delete = Delete;
 
        return service;
 
        function GetAll() {
            return $http.get('/api/users').then(handleSuccess, handleError('Error getting all users'));
        }
 
        function GetById(id) {
            return $http.get('/api/users/' + id).then(handleSuccess, handleError('Error getting user by id'));
        }
 
        function GetByUsername(username) {
            return $http.get('/api/users/' + username).then(handleSuccess, handleError('Error getting user by username'));
        }
 
        function Create(user) {
            return $http.post('/api/users', user).then(handleSuccess, handleError('Error creating user'));
        }
 
        function Update(user) {
            return $http.put('/api/users/' + user.id, user).then(handleSuccess, handleError('Error updating user'));
        }
 
        function Delete(id) {
            return $http.delete('/api/users/' + id).then(handleSuccess, handleError('Error deleting user'));
        }
 
        // private functions
 
        function handleSuccess(res) {
            return res.data;
        }
 
        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }
    }
    */
})();
(function () {
    'use strict';
 
    angular
        .module('skogscalcPublik')
        .factory('CurrentSessionService', CurrentSessionService);
 
    /** @ngInject */
    function CurrentSessionService() { //$timeout, $filter, $q
        
        var service = {};
        
        service.Reset = Reset;

        service.SetSkogsbruksplan = SetSkogsbruksplan;
        service.SetSkogsbruksplanAktiv = SetSkogsbruksplanAktiv;
        service.GetSkogsbruksplan = GetSkogsbruksplan;
        service.SetParams = SetParams;
        service.GetParams = GetParams;
        service.SetPrognos = SetPrognos;
        service.GetPrognos = GetPrognos;
        service.SetPrognosParams = SetPrognosParams;
        service.GetPrognosParams = GetPrognosParams;
        service.getSBPName = getSBPName;
        service.setSBPName = setSBPName;
        

        var skogsbruksplaner = {
            grundplan: null,
            uppraeknadplan: null,
            aktiv: null
        }

        var params = null;

        var prognos = null;

        var prognosParams = null

        var SBPName = "";


        function getSBPName() {
            return SBPName;
        }

        function setSBPName(name) {
            SBPName = name;
        }

        function Reset() {
            skogsbruksplaner = {
                grundplan: null,
                uppraeknadplan: null,
                aktiv: null
            }

            params = null;
            prognos = null;
            prognosParams = null
        }

        function SetSkogsbruksplan(grundplan, uppraeknadplan, aktiv) {
            skogsbruksplaner.grundplan = grundplan;
            skogsbruksplaner.uppraeknadplan = uppraeknadplan;
            skogsbruksplaner.aktiv = aktiv;
        }

        function SetSkogsbruksplanAktiv(aktiv) {
            skogsbruksplaner.aktiv = aktiv;
        }

        function GetSkogsbruksplan() {
            if (skogsbruksplaner.aktiv == "grund") {
                return skogsbruksplaner.grundplan;
            } else {
                return skogsbruksplaner.uppraeknadplan;
            }
        }

        function SetParams(data) {
            params = data;
        }

        function GetParams() {
            return params;
        }

        function SetPrognos(data) {
            prognos = data;
        }

        function GetPrognos() {
            return prognos;
        }

        function SetPrognosParams(data) {
            prognosParams = data;
        }

        function GetPrognosParams() {
            return prognosParams;
        }

        return service;
    }
})();
(function () {
    'use strict';
 
    angular
        .module('skogscalcPublik')
        .factory('ChartService', ChartService);
 
    /** @ngInject */
    function ChartService() { //$timeout, $filter, $q
        
        var service = {};
        
        service.SetSbpChart = SetSbpChart;
        service.SetResultatChart = SetResultatChart;
        service.SetSkogChart = SetSkogChart;

        service.SetSbpData = SetSbpData;
        service.SetResultatData = SetResultatData;
        service.SetSkogData = SetSkogData;

        service.DrawAll = drawCharts;
        service.ToImagesCallback = ToImagesCallback;
        service.GetAldersdata = GetAldersdata;


        var chartsLoaded = false;

        var charts = {
            sbp: null,
            resultat: null,
            skog: null  
        }

        var aldersdata = [
            'Kalmark',
            '0 - 9',
            '10 - 19',
            '20 - 29',
            '30 - 39',
            '40 - 49',
            '50 - 59',
            '60 - 69',
            '70 - 79',
            '80 - 89',
            '90 - 99',
            '100 - 109',
            '110 - 119',
            '120+',
            'Lågproduktiv skog'
        ];

        function GetAldersdata() {
            return aldersdata;
        }

        //google.load('visualization', '1.1', {packages: ['corechart'], callback: drawVisualization});

        google.charts.load('current', {packages: ['corechart'], 'language': 'sv'});
        google.charts.setOnLoadCallback(drawVisualization);



        function drawVisualization(argument) {
            chartsLoaded = true;
            handleChartsCallback(drawCharts);
        }


        function SetSbpChart(div) {
            handleChartsCallback(setSbpChart, div);
        }
        function SetSbpData(data) {
            handleChartsCallback(setSbpData, data);
        }
        function setSbpChart(div) {
            charts.sbp = new ChartSBP(div, aldersdata);
        }
        function setSbpData(data) {
            charts.sbp.setData(data, true);
        }

        function SetSkogChart(div) {
            handleChartsCallback(setSkogChart, div);
        }
        function SetSkogData(total, avverkningsbar_alder, avverkningsbar_reglerad_kvar) {
            handleChartsCallback(setSkogData, {total:total, avverkningsbar_alder: avverkningsbar_alder, avverkningsbar_reglerad_kvar: avverkningsbar_reglerad_kvar});
        }

        function setSkogChart(div) {
            charts.skog = new ChartSkog(div);
        }        
        function setSkogData(attrs) {
            charts.skog.setData(attrs.total, attrs.avverkningsbar_alder, attrs.avverkningsbar_reglerad_kvar, true);
        }

        function SetResultatChart(div) {
            handleChartsCallback(setResultatChart, div);
        }
        function setResultatChart(div) {
            charts.resultat = new ChartResultat(div);
        }

        function SetResultatData(resultat, pantbrevskostnad, resultat_aggregerat) {
            handleChartsCallback(setResultatData, {resultat:resultat, pantbrevskostnad: pantbrevskostnad, resultat_aggregerat: resultat_aggregerat});
        }

        function setResultatData(attrs) {
            charts.resultat.setData(attrs.resultat, attrs.pantbrevskostnad, attrs.resultat_aggregerat, true);
        }


        function ToImagesCallback(callback) {
            handleChartsCallback(toImagesCallback, callback);
        }

        function toImagesCallback(callback) {
            var nrOfCharts = 0;
            var nrReady = 0;
            
            if (charts.sbp != null) {
                nrOfCharts++;
                charts.sbp.addReadyListener(function (div, chart) {
                    div.innerHTML = '<img src="' + chart.getImageURI() + '">';
                    ready();
                });
            }

            if (charts.resultat != null) {
                nrOfCharts++;
                charts.resultat.addReadyListener(function (div, chart) {
                    div.innerHTML = '<img src="' + chart.getImageURI() + '">';
                    ready();
                });
            }

            if (charts.skog != null) {
                nrOfCharts++;
                charts.skog.addReadyListener(function (div, chart) {
                    div.innerHTML = '<img src="' + chart.getImageURI() + '">';
                    ready();
                });
            }

            function ready() {
                nrReady++;
                if (nrOfCharts == nrReady) {
                    callback();    
                }
            }
        }


        function drawCharts() {
            for (var i in charts) {
                if (charts[i]) {
                    charts[i].render();
                }
            }
        }

        var handleChartsCallbacks = [];
        function handleChartsCallback(callback, attrs) {
            if (!chartsLoaded) {
                handleChartsCallbacks.push({callback:callback, attrs:attrs}); 
            } else {
                if (handleChartsCallbacks.length > 0) {
                    for(var i in handleChartsCallbacks) {
                        handleChartsCallbacks[i].callback(handleChartsCallbacks[i].attrs);
                    }
                    handleChartsCallbacks = [];
                }
                callback(attrs);
            }
        }        

        return service;
    }
})();
(function() {
    'use strict';

    angular.module('core', []);
})();

(function() {
	'use strict';

	angular.
	module('core').
	filter('numberthousand', function() {
		return function(input, nrDecimals) {
			var str = input.toString();
			var splitted = splitStringOnFirstChar(str, '.');

			var integer = splitted[0];
			var decimal = splitted[1];

			for(var i = 0; i < splitted[0].length; i++) {
				if (i%3 == 0 && i!=0) {
					integer = stringAdd(integer, splitted[0].length-i, ' ');
				}
			}

			return integer;
		};
	});

	function getNrOccurences(str, char) {
		return (str.match(new RegExp(char, 'g')) || []).length;
	}

	function splitStringOnFirstChar(str, char) {
		if (str.indexOf(char) > -1 ) {
			return [str.substring(0, str.indexOf(char)), str.substring(str.indexOf(char)+1)]
		} 
		return [str, null];

	}

	function stringAdd(str, start, newSubStr) {
		return str.slice(0, start) + newSubStr + str.slice(start);
	}


})();

(function() {

    // Create global filters using angular.filter() only. Never use local filters inside
    // controllers/services. This enhances testing and reusability.
    function xpTypeaheadFilter() {
          return function(items, props) {

            var out = [];
            
            if (angular.isArray(items)) {

              items.forEach(function(item) {
                
                


                var text = props.toLowerCase();
                var itemLoverCase =item.namn.toLowerCase();
                var substr = itemLoverCase.substr(0, text.length);

                 
                if (substr === text ) {
                    
                     out.push(item);
                     
                }
                

              });
            } else {
              // Let the output be the input untouched
              out = items;
            }

            return out;
          };
    }

    // Pass functions into module methods rather than assigning a callback.
    // This helps aid with readability and helps reduced the amount of code "wrapped"
    // inside Angular.
    angular.module('core')
    .filter('xpTypeaheadFilter', xpTypeaheadFilter);
})();



(function() {
	'use strict';

	angular
	.module('core')
	.filter('numbershort', function() {
		return function(input, unit) {
			var output = Math.round(input);
			var ending = '';
			var negative = isNegative(input);

			output = Math.abs(output);

			if (output > 1000) {
				output = Math.round(output / 100) / 10;
				ending = 't';
			}

			if (output > 1000) {
				output = Math.round(output / 100) / 10;
				ending = 'mn'
			}

			if (output > 1000) {
				output = Math.round(output / 100) / 10;
				ending = 'md'
			}

			output = negative ? output * -1 : output;

			output = output.toString().replace('.', ',');

			return output + ' ' + ending + unit;
		};
	});




	function isNegative(value) {
		return value < 0;
	}
})();




(function() {
  'use strict';

  angular
      .module('skogscalcPublik')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .controller('SidebarModalController', SidebarModalController)
    .directive('sidebarModal', sidebarModal)


    .directive('sbpModalTransclude', ['$animate', function($animate) {
        return {
          link: function(scope, element, attrs, controller, transclude) {
            transclude(scope.$parent, function(clone) {
              element.empty();
              $animate.enter(clone, element);
            });
          }
        };
    }])
    


    .factory('$sbpModalStack', ['$animate', '$animateCss', '$document',
        '$compile', '$rootScope', '$q', 
        function($animate, $animateCss, $document, $compile, $rootScope, $q) {
          var OPENED_MODAL_CLASS = 'modal-open';

          
          var openedWindow = null; //$$stackedMap.createNew();
          var openedClass =  null; //$$multiMap.createNew();
          var $sbpModalStack = {
            NOW_CLOSING_EVENT: 'modal.stack.now-closing'
          };
          


          function removeModalWindow(modalInstance) {
            var modalWindow = openedWindow;//openedWindow.get(modalInstance).value;
            var appendToElement = modalWindow.appendTo;

            //clean up the stack
            openedWindow = null; //.remove(modalInstance);

            removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
              var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
              openedClass = null
              appendToElement.toggleClass(modalBodyClass, false);
              toggleTopWindowClass(true);
            }, modalWindow.closedDeferred);
            
          }

          // Add or remove "windowTopClass" from the top window in the stack
          function toggleTopWindowClass(toggleSwitch) {
            if (openedWindow) {
              openedWindow.modalDomEl.toggleClass(openedWindow.windowTopClass || '', toggleSwitch);
            }
          }

          

          function removeAfterAnimate(domEl, scope, done, closedDeferred) {
            var asyncDeferred;
            var asyncPromise = null;
            var setIsAsync = function() {
              if (!asyncDeferred) {
                asyncDeferred = $q.defer();
                asyncPromise = asyncDeferred.promise;
              }

              return function asyncDone() {
                asyncDeferred.resolve();
              };
            };
            

            // Note that it's intentional that asyncPromise might be null.
            // That's when setIsAsync has not been called during the
            // NOW_CLOSING_EVENT broadcast.
            return $q.when(asyncPromise).then(afterAnimating);

            function afterAnimating() {
              if (afterAnimating.done) {
                return;
              }
              afterAnimating.done = true;

              $animate.leave(domEl).then(function() {
                if (done) {
                    scope.$broadcast($sbpModalStack.NOW_CLOSING_EVENT, setIsAsync);
                    done();
                }

                domEl.remove();
                if (closedDeferred) {
                  closedDeferred.resolve();
                }
              });

              scope.$destroy();
            }
          }

          $document.on('keydown', keydownListener);

          $rootScope.$on('$destroy', function() {
            $document.off('keydown', keydownListener);
          });

          function keydownListener(evt) {
            if (evt.isDefaultPrevented()) {
              return evt;
            }

            var modal = openedWindow;
            if (modal) {
              switch (evt.which) {
                case 27: {
                  if (modal.value.keyboard) {
                    evt.preventDefault();
                    $rootScope.$apply(function() {
                      $sbpModalStack.dismiss(modal.key, 'escape key press');
                    });
                  }
                  break;
                }
              }
            }
          }

        $sbpModalStack.getTop = function(modalInstance, modal) {
            return openedWindow;
        }          

          $sbpModalStack.open = function(modalInstance, modal) {
            var modalOpener = $document[0].activeElement,
              modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

            toggleTopWindowClass(false);

            openedWindow = {
              deferred: modal.deferred,
              renderDeferred: modal.renderDeferred,
              closedDeferred: modal.closedDeferred,
              modalScope: modal.scope,
              keyboard: modal.keyboard,
              openedClass: modal.openedClass,
              windowTopClass: modal.windowTopClass,
              animation: modal.animation,
              appendTo: modal.appendTo
            };

            openedClass = modalBodyClass;

            var appendToElement = modal.appendTo;

            if (!appendToElement.length) {
              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
            }

            
            
            //var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
            var angularDomEl = angular.element('<div sbp-modal-window="modal-window"></div>');
            angularDomEl.attr({
              'class': 'sbp-modal',
              'template-url': modal.windowTemplateUrl,
              'window-top-class': modal.windowTopClass,
              'role': 'dialog',
              'aria-labelledby': modal.ariaLabelledBy,
              'aria-describedby': modal.ariaDescribedBy,
              'size': modal.size,
              
              'animate': 'animate',
              
              
              'uib-modal-animation-class': 'fade',
              'modal-in-class': 'in'
            }).html(modal.content);
            if (modal.windowClass) {
              angularDomEl.addClass(modal.windowClass);
            }

            if (modal.animation) {
              angularDomEl.attr('modal-animation', 'true');
            }

            appendToElement.addClass(modalBodyClass);

            $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

            openedWindow.modalDomEl = angularDomEl;
            openedWindow.modalOpener = modalOpener;
          };

          function broadcastClosing(modalWindow, resultOrReason, closing) {
            return !modalWindow.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
          }

          $sbpModalStack.close = function(result) {
            if (openedWindow && broadcastClosing(openedWindow, result, true)) {
              openedWindow.modalScope.$$sbpDestructionScheduled = true;
              openedWindow.deferred.resolve(result);
              removeModalWindow(openedWindow);
              return true;
            }
            return !openedWindow;
          };

          $sbpModalStack.dismiss = function(reason) {
            if (openedWindow && broadcastClosing(openedWindow, reason, false)) {
              openedWindow.modalScope.$$sbpDestructionScheduled = true;
              openedWindow.deferred.reject(reason);
              removeModalWindow(openedWindow);
              return true;
            }
            return !openedWindow;
          };


          $sbpModalStack.modalRendered = function() {
            if (openedWindow) {
              openedWindow.renderDeferred.resolve();
            }
          };


          return $sbpModalStack;
        }])

    .provider('$sbpResolve', function() {
        var resolve = this;
        this.resolver = null;

        this.setResolver = function(resolver) {
          this.resolver = resolver;
        };

        this.$get = ['$injector', '$q', function($injector, $q) {
          var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
          return {
            resolve: function(invocables, locals, parent, self) {
              if (resolver) {
                return resolver.resolve(invocables, locals, parent, self);
              }

              var promises = [];

              angular.forEach(invocables, function(value) {
                if (angular.isFunction(value) || angular.isArray(value)) {
                  promises.push($q.resolve($injector.invoke(value)));
                } else if (angular.isString(value)) {
                  promises.push($q.resolve($injector.get(value)));
                } else {
                  promises.push($q.resolve(value));
                }
              });

              return $q.all(promises).then(function(resolves) {
                var resolveObj = {};
                var resolveIter = 0;
                angular.forEach(invocables, function(value, key) {
                  resolveObj[key] = resolves[resolveIter++];
                });

                return resolveObj;
              });
            }
          };
        }];
    })

    .provider('$sbpModal', function() {
        var $modalProvider = {
            options: {
                animation: true,
                keyboard: true
            },
            $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$sbpResolve', "$sbpModalStack",
                function ($rootScope, $q, $document, $templateRequest, $controller, $sbpResolve, $sbpModalStack) {
                    var $modal = {};

                    function getTemplatePromise(options) {
                        return options.template ? $q.when(options.template) :
                            $templateRequest(angular.isFunction(options.templateUrl) ?
                            options.templateUrl() : options.templateUrl);
                    }

                    var promiseChain = null;
                    $modal.getPromiseChain = function() {
                        return promiseChain;
                    };

                    $modal.open = function(modalOptions) {
                        var modalResultDeferred = $q.defer();
                        var modalOpenedDeferred = $q.defer();
                        var modalClosedDeferred = $q.defer();
                        var modalRenderDeferred = $q.defer();

                        //prepare an instance of a modal to be injected into controllers and returned to a caller
                        var modalInstance = {
                            result: modalResultDeferred.promise,
                            opened: modalOpenedDeferred.promise,
                            closed: modalClosedDeferred.promise,
                            rendered: modalRenderDeferred.promise,
                            close: function (result) {
                                return $sbpModalStack.close(result);
                            },
                            dismiss: function (reason) {
                                return $sbpModalStack.dismiss(reason);
                            }
                        };

                        //merge and clean up options
                        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
                        modalOptions.resolve = modalOptions.resolve || {};
                        modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

                        //verify options
                        if (!modalOptions.template && !modalOptions.templateUrl) {
                            throw new Error('One of template or templateUrl options is required.');
                        }

                        var templateAndResolvePromise =
                            $q.all([getTemplatePromise(modalOptions), $sbpResolve.resolve(modalOptions.resolve, {}, null, null)]);

                        function resolveWithTemplate() {
                            return templateAndResolvePromise;
                        }

                    // Wait for the resolution of the existing promise chain.
                    // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
                    // Then add to $sbpModalStack and resolve opened.
                    // Finally clean up the chain variable if no subsequent modal has overwritten it.
                    var samePromise;
                    samePromise = promiseChain = $q.all([promiseChain])
                        .then(resolveWithTemplate, resolveWithTemplate)
                        .then(function resolveSuccess(tplAndVars) {
                            var providedScope = modalOptions.scope || $rootScope;

                            var modalScope = providedScope.$new();
                            modalScope.$close = modalInstance.close;
                            modalScope.$dismiss = modalInstance.dismiss;

                            modalScope.$on('$destroy', function() {
                                if (!modalScope.$$sbpDestructionScheduled) {
                                    modalScope.$dismiss('$uibUnscheduledDestruction');
                                }
                            });

                            var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                            //controllers
                            if (modalOptions.controller) {
                                ctrlLocals.$scope = modalScope;
                                ctrlLocals.$scope.$resolve = {};
                                ctrlLocals.$sbpModalInstance = modalInstance;
                                angular.forEach(tplAndVars[1], function(value, key) {
                                    ctrlLocals[key] = value;
                                    ctrlLocals.$scope.$resolve[key] = value;
                                });

                                // the third param will make the controller instantiate later,private api
                                // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                                ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                                if (modalOptions.controllerAs && modalOptions.bindToController) {
                                    ctrlInstance = ctrlInstantiate.instance;
                                    ctrlInstance.$close = modalScope.$close;
                                    ctrlInstance.$dismiss = modalScope.$dismiss;
                                    angular.extend(ctrlInstance, {
                                        $resolve: ctrlLocals.$scope.$resolve
                                    }, providedScope);
                                }

                                ctrlInstance = ctrlInstantiate();

                                if (angular.isFunction(ctrlInstance.$onInit)) {
                                    ctrlInstance.$onInit();
                                }
                            }

                            $sbpModalStack.open(modalInstance, {
                                scope: modalScope,
                                deferred: modalResultDeferred,
                                renderDeferred: modalRenderDeferred,
                                closedDeferred: modalClosedDeferred,
                                content: tplAndVars[0],
                                animation: modalOptions.animation,
                                
                                keyboard: modalOptions.keyboard,
                                
                                windowTopClass: modalOptions.windowTopClass,
                                windowClass: modalOptions.windowClass,
                                windowTemplateUrl: modalOptions.windowTemplateUrl,
                                ariaLabelledBy: modalOptions.ariaLabelledBy,
                                ariaDescribedBy: modalOptions.ariaDescribedBy,
                                size: modalOptions.size,
                                openedClass: modalOptions.openedClass,
                                appendTo: modalOptions.appendTo
                            });
                            modalOpenedDeferred.resolve(true);

                        }, function resolveError(reason) {
                            modalOpenedDeferred.reject(reason);
                            modalResultDeferred.reject(reason);
                        })['finally'](function() {
                            if (promiseChain === samePromise) {
                                promiseChain = null;
                            }
                        });

                        return modalInstance;
                    };

                    return $modal;
                }
            ]
        };
        return $modalProvider;
    })

    .directive('sbpModalAnimationClass', function() {
        return {
          compile: function(tElement, tAttrs) {
            if (tAttrs.modalAnimation) {
              tElement.addClass(tAttrs.sbpModalAnimationClass);
            }
          }
        };
    })

    .directive('sbpModalWindow', ['$sbpModalStack', '$q', '$animateCss', '$document',
      function($modalStack, $q, $animateCss, $document) {
        return {
          scope: {
            index: '@'
          },
          restrict: 'A',
          transclude: true,
          templateUrl: function(tElement, tAttrs) {
            return tAttrs.templateUrl || 'app/components/sidebarModal/sidebarModal.html';
          },
          link: function(scope, element, attrs) {
            element.addClass(attrs.windowTopClass || '');
            scope.size = attrs.size;

            scope.close = function(evt) {
              var modal = $modalStack.getTop();
            };

            // moved from template to fix issue #2280
            element.on('click', scope.close);

            // This property is only added to the scope for the purpose of detecting when this directive is rendered.
            // We can detect that by using this property in the template associated with this directive and then use
            // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
            scope.$isRendered = true;

            // Deferred object that will be resolved when this modal is render.
            var modalRenderDeferObj = $q.defer();
            // Resolve render promise post-digest
            scope.$$postDigest(function() {
              modalRenderDeferObj.resolve();
            });

            modalRenderDeferObj.promise.then(function() {
              var animationPromise = null;

              if (attrs.modalInClass) {
                animationPromise = $animateCss(element, {
                  addClass: attrs.modalInClass
                }).start();

                scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
                  var done = setIsAsync();
                  $animateCss(element, {
                    removeClass: attrs.modalInClass
                  }).start().then(done);
                });
              }


              $q.when(animationPromise).then(function() {
                $modalStack.modalRendered();
              });
            });
          }
        };
    }])


    /** @ngInject */
    function sidebarModal() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {
                creationDate: '='
            },
            controller: 'SbpSidebarController',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        
    }

    /** @ngInject */
    function SidebarModalController(AuthenticationService, $log) {
        var vm = this;
        vm.user = AuthenticationService.GetUserName()
    }





})();







(function () {
    'use strict';
 
    angular
        .module('skogscalcPublik')
        .controller('RegisterController', RegisterController);
 
    RegisterController.$inject = ['UserService', '$location', '$rootScope', 'notify'];
    function RegisterController(UserService, $location, $rootScope, notify) {
        var vm = this;
 
        vm.register = register;
 
        function register() {
            vm.dataLoading = true;
            UserService.Create(vm.user)
                .then(function (response) {
                    if (response.success) {
                        notify('Registration successful', true);
                        $location.path('/login');
                    } else {
                        notify(response.message);
                        vm.dataLoading = false;
                    }
                });
        }
    }
 
})();
(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .directive('paperSelectInput', paperSelectInput);


    /** @ngInject */
    function paperSelectInput() {
        var directive = {
            require: "?ngModel",
            restrict: 'E',
            templateUrl: 'app/components/paperSelectInput/paperSelectInput.html',
            css: 'app/components/paperSelectInput/paperSelectInput.css',
            scope: {
                choices: "=",
                disabled: "="
            },
            link: function(scope, element, attrs, ngModel){
                if (!ngModel) return;

                var defaultValue = '-----';
                var chosenTopVal = 0;


                ngModel.$render = function(){
                    scope.value = ngModel.$viewValue;
                    scope.chosenTop = ""+chosenTopVal+"px";

                };


                scope.onChose = function ($event, choice, $index) {
                    var target = angular.element($event.target);
                    ngModel.$setViewValue(choice[0]);
                    scope.value = ngModel.$viewValue;
                    setPosition($index);
                }

                
                ngModel.$parsers.push(function(data) {
                    //View -> Model
                    for (var i = scope.choices.length - 1; i >= 0; i--) {
                        if(scope.choices[i][0] === data) {
                            return scope.choices[i][1]
                        }
                    }
                });

                ngModel.$formatters.push(function(data) {
                    //Model -> View
                    for (var i = scope.choices.length - 1; i >= 0; i--) {
                        if(scope.choices[i][1] === data) {
                            return scope.choices[i][0]
                        }
                    }
                    return defaultValue;
                });
                

                function setPosition(index) {
                    var container = angular.element(element[0].querySelector('.psi-choses'));

                    var children = container.children();

                    var chosenChild = children[index];

                    scope.chosenTop = "-"+chosenChild.offsetTop+"px";
                }
            }
        };
        return directive;
    }

})();

(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .filter('numbertostring', function() {
        return function(input) {
            if(!isEmpty(input)) {
                input = ""+input;
                var newValues = input.split(/,(.+)/);
                newValues[0] = newValues[0].replace(new RegExp(' ', 'g'), '');

                var maxIndex = newValues[0].length;
                var currentIndex = maxIndex % 3;
                if (currentIndex == 0) {
                    currentIndex += 3; 
                }

                while (currentIndex < maxIndex) {
                    newValues[0] = stringAdd(newValues[0], currentIndex, " ");
                    
                    currentIndex = currentIndex + 4;
                }


                if (newValues.length > 1) {
                    var decimals = newValues[1].replace(',', '');
                    return ""+newValues[0]+","+decimals;
                } else {
                    return ""+newValues[0];
                }
            }
        };
    })
    .filter('stringtonumber', function() {
        return function(input) {
            input = ""+input;
            input = input.replace(new RegExp(' ', 'g'), '');
            input = input.replace(',', '.');
            return parseFloat(input);
        };
    })
    .directive('paperInputBak', paperInput);
    

    /** @ngInject */
    function paperInput($sce, $filter, numbertostringFilter, stringtonumberFilter) {
        var directive = {
            require: "?ngModel",
            restrict: 'E',
            templateUrl: 'app/components/paperInput_bak/paperInput.html',
            css: 'app/components/paperInput_bak/paperInput.css',
            scope: {
                labelUnsafe: "@piLabel",
                errorLabel: "@piErrorLabel",
                choices: "=piChoices",
                type: "@",
                required: "=",
                disabled: "=",
                pattern: "@",
                step: "@",
                name: "@",
                autocomplete: "@"
            },
            link: function(scope, element, attrs, ngModel){
                if (!ngModel) return;


                var rootElement = element.children();

                scope.onChange = function(){

                    if (!scope.isSelect) {                    
                        ngModel.$setViewValue(scope.value);
                        if (!isEmpty(ngModel.$viewValue)) {
                            scope.errors = ngModel.$invalid;
                        } else if (isEmpty(ngModel.$viewValue) && scope.required) {
                            scope.errors = true;
                        }
                    } else {
                        scope.done = false;
                    }
                };

                scope.onFocus = function(){
                    rootElement.removeClass("pi-label-move pi-focus");
                    rootElement.addClass("pi-focus");
                }

                scope.onBlur = function(){
                    rootElement.removeClass("pi-focus");
                    if (isEmpty(ngModel.$viewValue) && !scope.isSelect) {
                        rootElement.addClass("pi-label-move");
                    }

                    if (scope.isSelect && !scope.done) {
                        scope.errors = true;
                    }
                }

                scope.$watch('value', function(newValue, oldValue) {
                    // access new and old value here
                    //console.log("watch: "+oldValue+", "+newValue);
                    //scope.value = numbertostringFilter(newValue);
                    //setTimeout(function(){
                    //    scope.value = numbertostringFilter(newValue);
                    //},0)
                });
                
                scope.onKeyDown = function($event) {
                    /*
                    console.log($event.keyCode);
                    if (scope.type === 'number') {
                        //space:  $event.keyCode == 32
                        var input = $event.currentTarget;
                        var carretPos = doGetCaretPosition(input);

                        if (($event.keyCode >= 48 && $event.keyCode <= 57) || ($event.keyCode >= 96 && $event.keyCode <= 105)  || $event.keyCode == 188) {



                            var newValue = stringAdd($event.currentTarget.value, carretPos, $event.key);
                            var before = getNrOccurences(newValue, ' ');
                            $event.currentTarget.value = numbertostringFilter(newValue);
                            var after = getNrOccurences($event.currentTarget.value, ' ');

                            setCaretPosition(input, carretPos+1 +(after-before));


                            $event.stopPropagation();
                            $event.preventDefault();

                            ngModel.$setViewValue(newValue);
                        } else if($event.keyCode == 8) { // delete 
                            console.log($event);

                            var bounds = getSelectionBounds(input);
                            var newValue = input.value;

                            if (bounds.start != bounds.end) {
                                newValue = stringRemoveRange(newValue, bounds.start, bounds.end)
                            } else {
                                var charToDelete = newValue.charAt(carretPos-1);
                                if (charToDelete === ' ') {
                                    newValue = stringRemoveChar(newValue, carretPos-1);
                                    carretPos--;
                                }
                                newValue = stringRemoveChar(newValue, carretPos-1);
                            }

                            newValue = numbertostringFilter(newValue);
                            ngModel.

                            console.log(newValue);


                            $event.currentTarget.value = newValue;

                            $event.stopPropagation();
                            $event.preventDefault();

                            ngModel.$setViewValue(newValue);
                        } else if($event.keyCode == 9) { // tab 
                            console.log("2")
                        } else if($event.keyCode >= 37 && $event.keyCode <= 40) { // arrow keys
                            
                        }
                        else {
                            $event.stopPropagation();
                            $event.preventDefault();
                        }
                        
                    }
                    */
                }
                /*
                if (scope.type === 'number') {

                    ngModel.$parsers.push(function(data) {
                        //View -> Model
                        return stringtonumberFilter(data);
                    });
                    ngModel.$formatters.push(function(data) {
                        //Model -> View
                        return numbertostringFilter(data);
                    });
                }
                */
                scope.onSelect = function($item, $model, $label) {
                    ngModel.$setViewValue($model);
                    scope.done = true;
                    scope.errors = false;
                }

                scope.getRequired = function() {
                    if (scope.required) {
                        return true;
                    } else {
                        return false;
                    }
                }

                ngModel.$render = function(){
                    if (!scope.disabled) {
                        scope.disabled = false;
                    }
                    scope.label = $sce.trustAsHtml(scope.labelUnsafe);
                    scope.value = ngModel.$viewValue;
                    scope.errors = ngModel.$error;
                    if (scope.choices) {
                        scope.isSelect = true;
                    } else {
                        scope.isSelect = false;
                    }
                    
                    if (!isEmpty(ngModel.$viewValue)) {
                        rootElement.removeClass("pi-label-move");
                    } 
                };
            }
        };
        return directive;
    }

    function isEmpty(elemVal) {
        return typeof elemVal == 'undefined' || elemVal === '' || elemVal === null;
    }

    function stringContains(str1, str2) {
        if( (""+str1).indexOf(str2) > -1 ) {
            return true;
        } else {
            return false;
        }
        
    }

    function doGetCaretPosition (oField) {

        // Initialize
        var iCaretPos = 0;

        // IE Support
        if (document.selection) {

            // Set focus on the element
            oField.focus();

            // To get cursor position, get empty selection range
            var oSel = document.selection.createRange();

            // Move selection start to 0 position
            oSel.moveStart('character', -oField.value.length);

            // The caret position is selection length
            iCaretPos = oSel.text.length;
        }

        // Firefox support
        else if (oField.selectionStart || oField.selectionStart == '0')
            iCaretPos = oField.selectionStart;

        // Return results
        return iCaretPos;
    }


    function getSelectionBounds (textComponent) {
        // IE version
        if (document.selection != undefined) {
            textComponent.focus();
            var sel = document.selection.createRange();
            return {start: sel.startOffset, end: sel.endOffset}
        }


        // Mozilla version
        else if (textComponent.selectionStart != undefined) {
            var startPos = textComponent.selectionStart;
            var endPos = textComponent.selectionEnd;
            return {start: startPos, end: endPos}
        }

    }
    

    function setCaretPosition(el, caretPos) {
        el.value = el.value;
        // ^ this is used to not only get "focus", but
        // to make sure we don't have it everything -selected-
        // (it causes an issue in chrome, and having it doesn't hurt any other browser)

        if (el !== null) {

            if (el.createTextRange) {
                var range = el.createTextRange();
                range.move('character', caretPos);
                range.select();
                return true;
            }

            else {
                // (el.selectionStart === 0 added for Firefox bug)
                if (el.selectionStart || el.selectionStart === 0) {
                    el.focus();
                    el.setSelectionRange(caretPos, caretPos);
                    return true;
                }

                else  { // fail city, fortunately this never happens (as far as I've tested) :)
                    el.focus();
                    return false;
                }
            }
        }
    }

    function getNrOccurences(str, char) {
        return (str.match(new RegExp(char, 'g')) || []).length;
    }

    function stringAdd(str, start, newSubStr) {
        return str.slice(0, start) + newSubStr + str.slice(start);
    }

    function stringRemoveChar(str, index) {
        return str.slice(0, index) + str.slice(index+1);
    }

    function stringRemoveRange(str, start, end) {
        return str.slice(0, start) + str.slice(end);
    }

})();


(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .directive('paperInput', paperInputNew);
    

    /** @ngInject */
    function paperInputNew($sce) {
        var directive = {
            require: "?ngModel",
            restrict: 'E',
            templateUrl: 'app/components/paperInput/paperInput.html',
            css: 'app/components/paperInput/paperInput.css',
            scope: {
                choices: "=",
                type: "@",
                required: "=",
                ngDisabled: "=",
                pattern: "@",
                step: "@",
                autocomplete: "@",
                labelUnsafe: "@label",
                labelUnsafeError: "@labelError",
                unitUnsafe: "@unit"
            },
            link: function(scope, element, attrs, ngModel){
                if (!ngModel) return;

                scope.hasErrors = false;
                scope.movetop = false;
                scope.isDone = false;
                scope.autocomplete = true;
                scope.isFocus = false;

                var rootElement = element.children();

                scope.onChange = function () {
                    ngModel.$setViewValue(scope.value);
                    if (scope.choices) {
                        scope.onBlur();    
                    }
                }

                var initial = false;
                scope.onFocus = function(){
                    scope.movetop = true;
                    scope.isFocus = true;
                }

                // FIX THIS
                scope.onBlur = function(){

                    scope.isFocus = false;
                    if (isEmpty(ngModel.$viewValue)) {
                        scope.movetop = true;
                        if (scope.required) {
                            scope.hasErrors = true;
                            ngModel.$setTouched();
                        }
                    } else {
                        scope.hasErrors = false;
                    }

                    if (scope.choices) {
                        if (valueIsInList(scope.choices, scope.value)) {
                            scope.isDone = true;
                            scope.hasErrors = false;
                        } else {
                            scope.isDone = false;
                            scope.hasErrors = true;
                        }
                    }

                }
                
                scope.onSelect = function($item, $model, $label) {
                    ngModel.$setViewValue($model);
                    scope.isDone = true;
                    scope.hasErrors = false;
                }

                scope.startsWith = function(state, viewValue) {
                    var substring = state.substr(0, viewValue.length);
                    substring = substring.toLowerCase();
                    return substring == viewValue.toLowerCase();
                } 


                ngModel.$render = function(){

                    scope.label = $sce.trustAsHtml(scope.labelUnsafe);
                    scope.labelError = $sce.trustAsHtml(scope.labelUnsafeError);
                    scope.unit = $sce.trustAsHtml(scope.unitUnsafe);
                    scope.value = ngModel.$viewValue;
                    scope.hasErrors = ngModel.$error;

                    if (scope.choices) {
                        scope.autocomplete = false;
                        if (valueIsInList(scope.choices, scope.value)) {
                            scope.isDone = true;
                        } else {
                            scope.isDone = false;
                        }
                    } 
                    
                    if (!isEmpty(ngModel.$viewValue)) {
                        scope.movetop = true;
                    } 


                };
            }
        };
        return directive;
    }

    function isEmpty(elemVal) {
        if (angular.isString(elemVal)) // typeof elemVal === 'string' || elemVal instanceof String
            return elemVal.length == 0;
        else if (angular.isNumber(elemVal)) { // typeof elemVal === 'number'
            return isNaN(elemVal);
        }
        else {
            return typeof elemVal === 'undefined' || elemVal === null;
        }
        //return typeof elemVal == 'undefined' || elemVal === '' || elemVal === null;
    }

    function valueIsInList(list, value) {
        for (var i = list.length - 1; i >= 0; i--) {
            if (list[i].namn == value) {
                return true;
            }
        }
        return false;
    }

})();


(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .directive('numberInput', numberInput);
    

    /** @ngInject */
    function numberInput($sce) {
        var directive = {
            require: "?ngModel",
            restrict: 'E',
            templateUrl: 'app/components/numberInput/numberInput.html',
            css: 'app/components/numberInput/numberInput.css',
            scope: {
                ngDisabled: "=",
                ngClass: "@",
                ngFocus: "=",
                ngBlur: "="
            },
            link: function(scope, element, attrs, ngModel){
                if (!ngModel) return;


                var input = element.children()[0];


                scope.onChange = function(newValue, oldValue) {
                    removeNonNumberFromInput(input, newValue);
                    removeWhiteSpacesFromInput(input)
                    addWhiteSpacesToInput(input);

                    ngModel.$setViewValue(stringToFloat(input.value));
                }


                scope.oldValue = "";

                scope.onKeyDown = function($event) {
                    scope.oldValue = input.value;
                }

                scope.onKeyUp = function($event) {
                    if (isCharacterKeyPress($event)) {
                        scope.onChange(input.value, scope.oldValue)    
                    }
                }

                ngModel.$render = function(){
                    if (TryParseInt(ngModel.$viewValue, null) != null) {
                        input.value = addWhiteSpacesToString(removeNonNumberChars(ngModel.$viewValue.toString().replace(".",",")));    
                    }
                    
                };
            }
        };
        return directive;
    }

    function TryParseInt(str,defaultValue) {
        var retValue = defaultValue;

        if(str !== null && typeof str !== 'undefined') {
            if (!isNaN(str)) {
                retValue = parseInt(str);
            }
        }
        return retValue;
    }


    function addWhiteSpacesToInput(input) {
        var carretPos = doGetCaretPosition(input);

        var splitted = splitStringOnFirstChar(input.value, ',');

        var integer = splitted[0];
        var decimal = splitted[1];

        for(var i = 0; i < splitted[0].length; i++) {
            if (i%3 == 0 && i!=0) {
                integer = stringAdd(integer, splitted[0].length-i, ' ');
                if (i < carretPos) {
                    carretPos++;    
                }
                
            }
        }

        if (decimal != null) {
            input.value = integer + ',' + decimal;                        
        } else {
            input.value = integer;
        }

        setCaretPosition(input, carretPos);
    }

    function addWhiteSpacesToString(str) {
        var splitted = splitStringOnFirstChar(str, ',');

        var integer = splitted[0];
        var decimal = splitted[1];

        for(var i = 0; i < splitted[0].length; i++) {
            if (i%3 == 0 && i!=0) {
                integer = stringAdd(integer, splitted[0].length-i, ' ');                
            }
        }

        if (decimal != null) {
            return integer + ',' + decimal;                        
        } else {
            return integer;
        }
    }

    function removeWhiteSpacesFromInput(input) {
        var carretBefore = doGetCaretPosition(input);
                    
        var splitted = splitString(input.value, carretBefore);

        var nrWhiteSpaces = getNrOccurences(splitted[0], /\s/);

        input.value = input.value.replace(/\s/g, ''); //.replace(/\s/g, '');

        setCaretPosition(input, carretBefore-nrWhiteSpaces);
    }

    function removeNonNumberFromInput(input, newValue) {
        var newStr = removeNonNumberChars(newValue);
                    
        var carretBefore = doGetCaretPosition(input);

        input.value = newStr;

        var diffCount = newValue.length - newStr.length;

        setCaretPosition(input, carretBefore-diffCount);
    }


    function isCharacterKeyPress(evt) {
        if (typeof evt.which == "undefined") {
            // This is IE, which only fires keypress events for printable keys
            return true;
        } else if (typeof evt.which == "number" && evt.which > 0) {
            // In other browsers except old versions of WebKit, evt.which is
            // only greater than zero if the keypress is a printable key.
            // We need to filter out backspace and ctrl/alt/meta key combinations
            return !evt.ctrlKey && !evt.metaKey && !evt.altKey && evt.which != 37 && evt.which != 39; // delete && evt.which != 8;
        }
        return false;
    } 

    function stringToFloat(str) {
        str = str.replace(',', '.');
        str = str.replace(/\s/g, '');
        return parseFloat(str);
    }

    function removeNonNumberChars(str) {
        var newStr = str.replace(/[^\d,-\s]/g, ''); //.replace(' ', '');  siffor: \d  mellanslag: \s
        var count = (newStr.match(/,/g) || []).length;

        if (count > 1) {
            var splitted = newStr.split(/,(.+)?/);
            splitted[1] = splitted[1].replace(',', '');
            newStr = splitted[0] + ',' + splitted[1];
        }

        return newStr;
    }


    function doGetCaretPosition (oField) {

        // Initialize
        var iCaretPos = 0;

        // IE Support
        if (document.selection) {

            // Set focus on the element
            oField.focus();

            // To get cursor position, get empty selection range
            var oSel = document.selection.createRange();

            // Move selection start to 0 position
            oSel.moveStart('character', -oField.value.length);

            // The caret position is selection length
            iCaretPos = oSel.text.length;
        }

        // Firefox support
        else if (oField.selectionStart || oField.selectionStart == '0')
            iCaretPos = oField.selectionStart;

        // Return results
        return iCaretPos;
    }
    

    function setCaretPosition(el, caretPos) {
        el.value = el.value;
        // ^ this is used to not only get "focus", but
        // to make sure we don't have it everything -selected-
        // (it causes an issue in chrome, and having it doesn't hurt any other browser)

        if (el !== null) {

            if (el.createTextRange) {
                var range = el.createTextRange();
                range.move('character', caretPos);
                range.select();
                return true;
            }

            else {
                // (el.selectionStart === 0 added for Firefox bug)
                if (el.selectionStart || el.selectionStart === 0) {
                    el.focus();
                    el.setSelectionRange(caretPos, caretPos);
                    return true;
                }

                else  { // fail city, fortunately this never happens (as far as I've tested) :)
                    el.focus();
                    return false;
                }
            }
        }
    }

    function splitString(value, index) {
        return [value.substring(0, index), value.substring(index)];
    }

    function getNrOccurences(str, char) {
        return (str.match(new RegExp(char, 'g')) || []).length;
    }


    function splitStringOnFirstChar(str, char) {
        if (str.indexOf(char) > -1 ) {
            return [str.substring(0, str.indexOf(char)), str.substring(str.indexOf(char)+1)]
        } 
        return [str, null];
        
    }

    function stringAdd(str, start, newSubStr) {
        return str.slice(0, start) + newSubStr + str.slice(start);
    }
})();

(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .controller('NavbarController', NavbarController)
    .directive('navbar', navbar);
    
    /** @ngInject */
    function navbar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {
                creationDate: '='
            },
            controller: 'NavbarController',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        
    }

    NavbarController.$inject = ['CurrentSessionService', '$log'];
    function NavbarController(CurrentSessionService, $log) {
        var vm = this;
        vm.sbp = CurrentSessionService.getSBPName();
        //console.log("name: ", vm.sbp)
        //vm.user = AuthenticationService.GetUserName()
        // "vm.creationDate" is available by directive option "bindToController: true"
        //vm.relativeDate = moment(vm.creationDate).fromNow();
    }

})();

(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .directive('multipleCheckbox', multipleCheckbox);
    


    /** @ngInject */
    function multipleCheckbox($sce, $timeout, $window) {
        var directive = {
            require: "?ngModel",
            restrict: 'E',
            templateUrl: 'app/components/multipleCheckbox/multipleCheckbox.html',
            css: 'app/components/multipleCheckbox/multipleCheckbox.css',
            scope: {
                choices: "=",
                ngDisabled: "="
            },
            link: function(scope, element, attrs, ngModel){
                if (!ngModel) return;

                scope.chosesModels = [];

                scope.onClick = function(event, choice){
                    var chosen = [];
                    for (var i = scope.chosesModels.length - 1; i >= 0; i--) {
                        if (scope.chosesModels[i].isChecked) {
                            chosen.push(scope.chosesModels[i].value);
                        }
                    }
                    ngModel.$setViewValue(chosen);
                };

                ngModel.$render = function(){
                    for (var i = 0; i < scope.choices.length; i++) {
                        scope.chosesModels.push(
                            {
                                isChecked: containsIn(scope.choices[i][1], ngModel.$viewValue), 
                                value: scope.choices[i][1],
                                label: scope.choices[i][0]
                            }
                        );
                    }
                };

                function containsIn(toCheck, list) {
                    for(var i in list) {
                        if (toCheck == list[i]) {
                            return true;
                        }
                    }
                    return false;
                }
            }
        };
        return directive;
    }



})();



(function() {
  'use strict';

  angular
    .module('skogscalcPublik')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();


(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .directive('loadingSpinner', loadingSpinner);
    

    /** @ngInject */
    function loadingSpinner($sce) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/loadingSpinner/loadingSpinner.html',
            css: 'app/components/loadingSpinner/loadingSpinner.css',
            scope: {
                enabled: "=",
                label: "@",
                size: "@"
            },
            link: function(scope, element, attrs){
                if (scope.size == 'auto') {
                    scope.$watch(
                        function () { 
                            var parent = element.parent();
                            return {
                                width: parent.prop('offsetWidth'),
                                height: parent.prop('offsetHeight')
                            }
                        },
                        function (newValue, oldValue) {
                            console.log("size changed: "+newValue.height+" : "+newValue.width);

                            if (newValue.height > newValue.width) {
                                scope.style = {
                                    'width' : newValue.height-2.5 + 'px',
                                    'height' : newValue.height-2.5 + 'px'
                                }
                            } else {
                                scope.style = {
                                    'width' : newValue.width + 'px',
                                    'height' : newValue.width + 'px'
                                }
                            }

                        },
                        true //deep watch
                    );    
                } else if (scope.size) {
                    var size = parseInt(scope.size);
                    scope.style = {
                        'width' : size + 'px',
                        'height' : size + 'px'
                    }
                }
            }
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .factory('githubContributor', githubContributor);

    /** @ngInject */
    function githubContributor($log, $http) {
        var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

        var service = {
            apiHost: apiHost,
            getContributors: getContributors
        };

        return service;

        function getContributors(limit) {
            if (!limit) {
                limit = 30;
            }

            return $http.get(apiHost + '/contributors?per_page=' + limit)
            .then(getContributorsComplete)
            .catch(getContributorsFailed);

            function getContributorsComplete(response) {
                return response.data;
            }

            function getContributorsFailed(error) {
                $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
            }
        }
    }
})();

(function () {
    'use strict';
 
    angular
        .module('skogscalcPublik')
        .factory('UserService', UserService);
 
    UserService.$inject = ['$http'];
    function UserService($http) {
        var service = {};
 
        service.GetAll = GetAll;
        service.GetById = GetById;
        service.GetByUsername = GetByUsername;
        service.Create = Create;
        service.Update = Update;
        service.Delete = Delete;
 
        return service;
 
        function GetAll() {
            return $http.get('/api/users').then(handleSuccess, handleError('Error getting all users'));
        }
 
        function GetById(id) {
            return $http.get('/api/users/' + id).then(handleSuccess, handleError('Error getting user by id'));
        }
 
        function GetByUsername(username) {
            return $http.get('/api/users/' + username).then(handleSuccess, handleError('Error getting user by username'));
        }
 
        function Create(user) {
            return $http.post('/api/users', user).then(handleSuccess, handleError('Error creating user'));
        }
 
        function Update(user) {
            return $http.put('/api/users/' + user.id, user).then(handleSuccess, handleError('Error updating user'));
        }
 
        function Delete(id) {
            return $http.delete('/api/users/' + id).then(handleSuccess, handleError('Error deleting user'));
        }
 
        // private functions
 
        function handleSuccess(res) {
            return res.data;
        }
 
        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }
    }
 
})();
(function () {
    'use strict';
 
    angular
        .module('skogscalcPublik')
        .factory('AuthenticationService', AuthenticationService);
 
    AuthenticationService.$inject = ['$http', '$cookies', '$rootScope', 'moment' ]; //'$windowProvider'
    function AuthenticationService($http, $cookies, $rootScope, $log, moment) { // $windowProvider
        var service = {};
        //var $window = $windowProvider.$get();
 
        service.Login = Login;
        service.SetCredentials = SetCredentials;
        service.ClearCredentials = ClearCredentials;
        service.Test = Test;
        service.GetUserName = GetUserName;
        service.HasCredentials = HasCredentials;
        service.TryLoggIn = TryLoggIn;



        return service;
 
        function Login(username, password, callback) {

            /*
            $http.post('/api/login/', { username: username, password: password })
                .success(function (response) {
                    callback(response);
                });
            */
            
            $http({
                url: "/api/login/",
                method: "POST",
                data: {username: username, password: password}
            }).then(function(Response) {
                Response.success = true;
                callback(Response)
            }, function(Response) {
                callback(Response)
            });
            
 
        }

        function Test(token) {
            $http({
                url: "/api/test/",
                method: "GET"
            }).then(function(Response) {
                $log(Response)
            }, function(Response) {
                $log(Response)
            });
        }
 
        function SetCredentials(token, username) {
            var authdata = Base64.encode(token+":"+username);

            $rootScope.globals = {
                currentUser: {
                    username : username,
                    token : token
                }
            };
 
            $http.defaults.headers.common['Authorization'] = 'Token ' + token; // jshint ignore:line

            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            $cookies.put('authorization', authdata, {expires:tomorrow});
        }
 
        function ClearCredentials() {
            $rootScope.globals = {};
            $cookies.remove('authorization');
            $http.defaults.headers.common.Authorization = 'Basic';
        }

        function GetCredentials() {
            var authorizationData = $cookies.get('authorization');
            var credentials = Base64.decode(authorizationData).split(':');
            var currentUser = {
                token : credentials[0],
                username : credentials[1]
            }
            return currentUser;
        }

        function GetUserName() {
            var userAndToken = Base64.decode($cookies.get('authorization'));
            var currentUser = userAndToken.split(':')[1];
            return currentUser;
        }

        function HasCredentials() {
            var authorization = $cookies.get('authorization');
            return typeof authorization !== 'undefined';
        }

        function TryLoggIn(callback) {
            var currentUser = GetCredentials();
            
            if (currentUser) {
                SetCredentials(currentUser.token, currentUser.username)
                $http({
                    url: "/api/test/",
                    method: "GET"
                }).then(function(Response) {
                    if (callback) {
                        callback(true);  
                    }
                    $log("Success loggin");
                }, function(Response) {
                    if (callback) {
                        callback(false);    
                    }
                    
                    $log("Fail loggin")
                });
                return true;
            }
            return false;
        }
    }
 
    // Base64 encoding service used by AuthenticationService
    var Base64 = {
 
        keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
 
        encode: function (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
 
            do {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);
 
                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;
 
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
 
                output = output +
                    this.keyStr.charAt(enc1) +
                    this.keyStr.charAt(enc2) +
                    this.keyStr.charAt(enc3) +
                    this.keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            } while (i < input.length);
 
            return output;
        },
 
        decode: function (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
 
            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            var base64test = /[^A-Za-z0-9\+\/\=]/g;
            if (base64test.exec(input)) {
                return false;
                /*
                $window.alert("There were invalid base64 characters in the input text.\n" +
                    "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
                    "Expect errors in decoding.");
                */
            }
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
 
            do {
                enc1 = this.keyStr.indexOf(input.charAt(i++));
                enc2 = this.keyStr.indexOf(input.charAt(i++));
                enc3 = this.keyStr.indexOf(input.charAt(i++));
                enc4 = this.keyStr.indexOf(input.charAt(i++));
 
                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;
 
                output = output + String.fromCharCode(chr1);
 
                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }
 
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
 
            } while (i < input.length);
 
            return output;
        }
    };
 
})();
(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .directive('animatedIf', animatedIf);

    /** @ngInject */
    function animatedIf($sce, $animate) {
        var directive = {
            transclude: 'element',
            priority: 600,
            terminal: true,
            restrict: 'A',
            $$tlb: true,
            scope: {
                animatedIf: '=',
                animatedIfEnterCallback: '&',
                animatedIfLeaveCallback: '&'
            },
            link: function ($scope, $element, $attr, ctrl, $transclude) {
                var block, childScope;
                $scope.$watch('animatedIf', function (value, oldValue) {

                    if (value) {
                        if (!childScope) {
                            //childScope = $scope.$new();
                            childScope = $scope.$parent.$new();
                            $transclude(childScope, function (clone) {
                                clone[clone.length++] = document.createComment(' end ngIf: ' + $attr.ngIf + ' ');
                                block = {
                                    clone: clone
                                };
                                var callback = !oldValue && $scope.animatedIfEnterCallback ? $scope.animatedIfEnterCallback : (function() {});
                                var parent = $element.parent();
                                //$animate.on('enter', parent, callback);
                                $animate.enter(clone[0], $element.parent(), $element, callback);
                            });
                        }
                    } else {
                    if (childScope) {
                        childScope.$destroy();
                        childScope = null;
                    }
                    if (block) {
                        $animate.leave(block.clone, ($scope.animatedIfLeaveCallback || (function() {})));
                        block = null;
                    }
                    }
                });
            }
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .directive('animationCallback', animationCallback);

    /** @ngInject */
    function animationCallback() {
        var directive = {
            restrict: 'A',
            scope: {
                animationCallback: '&'
            },
            link: function(scope, element) {
                var callback = scope.animationCallback();
                var events = 'animationend webkitAnimationEnd MSAnimationEnd transitionend webkitTransitionEnd';

                element.on(events, function(event) {
                    if (event.target == element[0]) {
                        callback.call(element[0], event);    
                    }
                });
            }
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
    .module('skogscalcPublik')
    .directive('androidCheckbox', androidCheckbox);
    


    /** @ngInject */
    function androidCheckbox($sce, $timeout, $window) {
        var directive = {
            require: "?ngModel",
            restrict: 'E',
            templateUrl: 'app/components/androidCheckbox/androidCheckbox.html',
            css: 'app/components/androidCheckbox/androidCheckbox.css',
            scope: {
                choices: "=acChoices",
                chosen: "@acChosen",
                ngDisabled: "="
            },
            link: function(scope, element, attrs, ngModel){
                if (!ngModel) return;

                var rootElement = element.children();
                var chosenElement = element[0].querySelector('.ac-chosen')
                var target = null;


                scope.onClick = function(event, choice){
                    target = angular.element(event.target)[0];
                    ngModel.$setViewValue(choice[1]);
                    moveToTarget();
                    
                };

                angular.element($window).bind('resize', function(){
                    moveToTarget();

                    // manuall $digest required as resize event
                    // is outside of angular
                    scope.$digest();
               });

                ngModel.$render = function(){
                    scope.leftVal = "0px";
                    $timeout(function() {
                        getTarget();


                    });
                };

                function getTarget() {
                    var choices = rootElement[0].querySelector('.ac-container');
                    choices = angular.element(choices.children);

                    for (var i = choices.length - 1; i >= 0; i--) {
                        target = angular.element(choices[i])[0];
                        var data = target.dataset.choice;
                        //if (data === scope.chosen) {
                        if (data == ngModel.$viewValue.toString()) {
                            moveToTarget(target);
                            break;
                        }
                    }
                }
                


                function moveToTarget() {
                    var currentX = chosenElement.offsetLeft;

                    var fixOffset = (target.clientWidth / 2) - (chosenElement.clientWidth / 2)

                    var relativeX = target.offsetLeft - currentX;

                    scope.leftVal = ""+(currentX + relativeX + fixOffset)+"px";

                }
            }
        };
        return directive;
    }



})();



(function() {
    'use strict';

    angular
        .module('skogscalcPublik')
        .directive('actionButton', actionButton);
    


    /** @ngInject */
    function actionButton($sce, $timeout, $window) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/actionButton/actionButton.html',
            css: 'app/components/actionButton/actionButton.css',
            scope: {
                text: "@",
                textConfirm: "@",
                textConfirmInfo: "@",
                textCancel: "@",
                onConfirm: "&",
                onBeforeConfirmCheck: "&"
            },
            link: function($scope, element, attrs){
                $scope.onStart = onStart;
                $scope.onCancel = onCancel;
                $scope.startIsClicked = false;




                function onStart(args,kvargs) {
                    if ($scope.onBeforeConfirmCheck() == true) {
                        $scope.startIsClicked = true;
                    }  
                }

                function onCancel(args,kvargs) {
                    $scope.startIsClicked = false;
                }

                /*
                scope.$watch(
                    function () { 
                        var parent = element.parent();
                        return {
                            width: parent.prop('offsetWidth'),
                            height: parent.prop('offsetHeight')
                        }
                    },
                    function (newValue, oldValue) {
                        console.log("size changed: "+newValue.height+" : "+newValue.width);

                        if (newValue.height > newValue.width) {
                            scope.style = {
                                'width' : newValue.height-2.5 + 'px',
                                'height' : newValue.height-2.5 + 'px'
                            }
                        } else {
                            scope.style = {
                                'width' : newValue.width + 'px',
                                'height' : newValue.width + 'px'
                            }
                        }

                    },
                    true //deep watch
                );  
                */ 
            }
        };
        return directive;
    }



})();



(function() {
  'use strict';

  angular
    .module('skogscalcPublik')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {

    'use strict';

    angular
        .module('skogscalcPublik')
        .config(routerConfig)
        .run(run);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main', {
                url: '/',
                templateUrl: 'app/views/main/main.html',
                controller: 'MainController',
                controllerAs: 'vm'
            })
           .state('start', {
                url: '/start',
                templateUrl: 'app/views/start/start.html',
                controller: 'StartController',
                controllerAs: 'vm'
            })
           .state('print', {
                url: '/print',
                templateUrl: 'app/views/print/print.html',
                controller: 'PrintController',
                controllerAs: 'vm'
            })
            .state('main.init', {
                url: 'init',
                templateUrl: 'app/views/init/init.html',
                controller: 'InitController',
                controllerAs: 'vm'
            })
            .state('main.skogsbruksplan', {
                url: 'sbp',
                templateUrl: 'app/views/sbp/sbp.html',
                controller: 'SBPController',
                controllerAs: 'vm'
            })
            .state('main.workspace', {
                url: 'workspace',
                templateUrl: 'app/views/wspace/wspace.html',
                controller: 'WSpaceController',
                controllerAs: 'vm',
                css: 'app/views/wspace/wspace.css'
            })

        $urlRouterProvider.otherwise('/start');
    }

    /* Should redirect to startpage if not done SBP */
    /** @ngInject */
    function run($rootScope, $location, $cookies, $http, AuthenticationService, $state, CurrentSessionService) {

        var handle = $rootScope.$on('$locationChangeStart', function (event, next, current) {

            if($cookies.get('sbp')) {
                var form = JSON.parse($cookies.get('sbp'));
                CurrentSessionService.SetSkogsbruksplan(form, null, "grund");
                var name = $cookies.get('sbpname');
                CurrentSessionService.setSBPName(name);

                $state.go('main.workspace');
            } else {
                $state.go('start');
            }
        });

        $rootScope.$on('$destroy', function() {
            handle();
        });
    }


})();






/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('skogscalcPublik')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('skogscalcPublik')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, localStorageServiceProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    localStorageServiceProvider.setPrefix('skogscalcPublik');
  }

})();

angular.module("skogscalcPublik").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/actionButton/actionButton.html","<div class=action-button-info-conatiner ng-class=\"[{\'state-before\': startIsClicked == false}, {\'state-after\': startIsClicked == true}]\"><div class=action-button-info>{{textConfirmInfo}}</div><div class=action-button-container ng-class=\"[{\'state-before\': startIsClicked == false}, {\'state-after\': startIsClicked == true}]\"><div class=\"action-button-item action-button-after action-button-cancel\" ng-click=onCancel()><div class=action-button-item-content>{{textCancel}}</div></div><div class=\"action-button-item action-button-after action-button-confirm\" ng-click=onConfirm()><div class=action-button-item-content>{{textConfirm}}</div></div><div class=\"action-button-item action-button-start\" ng-click=onStart()><div class=action-button-item-content>{{text}}</div></div></div></div>");
$templateCache.put("app/components/androidCheckbox/androidCheckbox.html","<div class=ac-outerwrapper ng-class=\"{\'ac-disabled\': ngDisabled == true}\"><div class=ac-wrapper><div class=ac-container><div class=ac-choice ng-repeat=\"choice in choices\" ng-click=\"onClick($event, choice)\" data-choice={{choice[1]}}>{{choice[0]}}</div></div></div><div class=ac-chosen ng-style=\"{\'left\': leftVal}\"></div></div>");
$templateCache.put("app/components/loadingSpinner/loadingSpinner.html","<div class=ls-container ng-show=enabled ng-style=style><div class=ls-spinner><div class=ls-animation ng-style=style><div></div><div></div></div><label class=ls-label ng-if=label>{{label}}</label></div></div>");
$templateCache.put("app/components/numberInput/numberInput.html","<input type=text ng-keydown=onKeyDown($event) ng-keyup=onKeyUp($event) ng-class=ngClass ng-focus=ngFocus() ng-blur=ngBlur() ng-disabled=ngDisabled>");
$templateCache.put("app/components/paperInput/paperInput.html","<div class=pin-container ng-class=\"[\n        {\'pin-haserror\': hasErrors == true}, \n        {\'pin-isdisabled\': ngDisabled == true}, \n        {\'pin-label-movetop\': movetop == true}, \n        {\'pin-isdone\': isDone == true},\n        {\'pin-isfocus\': isFocus == true}]\"><span class=pin-label ng-bind-html=label></span> <span class=pin-unit ng-show=\"isFocus || ngDisabled && movetop\" ng-bind-html=unit></span><number-input ng-model=value ng-show=\"type == \'number\'\" ng-class=pin-input ng-focus=onFocus ng-blur=onBlur ng-change=onChange() ng-disabled=ngDisabled></number-input><input ng-model=value ng-show=\"type == \'choose\'\" type={{type}} class=pin-input ng-class=\"{\'form-control\': choices}\" autocomplete={{autocomplete}} uib-typeahead=\"item.namn for item in choices | xpTypeaheadFilter:$viewValue | limitTo:8\" typeahead-on-select=onChange() ng-focus=onFocus() ng-blur=onBlur() ng-change=onChange() ng-disabled=ngDisabled> <input ng-model=value ng-show=\"type == \'text\'\" type={{type}} class=pin-input ng-focus=onFocus() ng-blur=onBlur() ng-change=onChange() ng-disabled=ngDisabled><!--\n    <input\n    	ng-attr-name=\'{{name}}\'\n    	ng-attr-step=\'{{step}}\'\n        type=\'text\'\n    	pattern=\'{{patterna}}\'\n    	ng-required=\'getRequired()\'\n    	ng-model=\'value\'\n    	ng-change=\'onChange()\'\n    	ng-focus=\'onFocus()\'\n    	ng-blur=\'onBlur()\'\n    	class=\"pi-input\"\n    	ng-class=\"[{\'pi-done\': errors==false}, {\'form-control\': isSelect==true}]\"\n    	uib-typeahead=\"item.namn for item in choices | filter:$viewValue | limitTo:8\"\n    	typeahead-on-select=\"onSelect($item, $model, $label)\"\n    	autocomplete=\"{{autocomplete}}\">\n    --> <span class=pin-done ng-if=\"isDone == true\"></span></div><!--ng-attr-type=\'{{type}}\'--> <!--ng-keydown=\'onKeyDown($event)\'-->");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><span class=navbar-name>{{ (vm.sbp === \'\') ? \"SkogsCALC\" : vm.sbp }} </span><a class=create-new ui-sref=start>Skapa ny</a></div><!--<div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\">\n      <ul class=\"nav navbar-nav\">\n\n        <li><a ui-sref=\"main.workspace\">Skrivbord</a></li>\n        <li><a ui-sref=\"main.archive\">Arkiv</a></li>\n        <li><a ui-sref=\"main.about\">Om</a></li>\n      </ul>\n\n      <ul class=\"nav navbar-nav navbar-right\">\n        <li><a ui-sref=\"start\">Skapa ny</a></li>\n        <li><span>{{vm.user}}</span></li>\n        <li><a ui-sref=\"login\">Logg out</a></li>\n      </ul>\n    </div>--></div></nav>");
$templateCache.put("app/components/multipleCheckbox/multipleCheckbox.html","<div class=mc-outerwrapper ng-class=\"{\'mc-disabled\': ngDisabled == true }\"><div class=mc-wrapper><div class=mc-container><div class=mc-choice ng-repeat=\"choice in chosesModels\"><div>{{choice.label}}</div><label class=mc-input><input type=checkbox ng-change=\"onClick($event, choice)\" ng-model=choice.isChecked ng-disabled=ngDisabled> <span></span></label></div></div></div></div>");
$templateCache.put("app/components/register/register.view.html","<div class=\"col-md-6 col-md-offset-3\"><h2>Register</h2><form name=form ng-submit=vm.register() role=form><div class=form-group ng-class=\"{ \'has-error\': form.firstName.$dirty && form.firstName.$error.required }\"><label for=username>First name</label><input type=text name=firstName id=firstName class=form-control ng-model=vm.user.firstName required> <span ng-show=\"form.firstName.$dirty && form.firstName.$error.required\" class=help-block>First name is required</span></div><div class=form-group ng-class=\"{ \'has-error\': form.lastName.$dirty && form.lastName.$error.required }\"><label for=username>Last name</label><input type=text name=lastName id=Text1 class=form-control ng-model=vm.user.lastName required> <span ng-show=\"form.lastName.$dirty && form.lastName.$error.required\" class=help-block>Last name is required</span></div><div class=form-group ng-class=\"{ \'has-error\': form.username.$dirty && form.username.$error.required }\"><label for=username>Username</label><input type=text name=username id=username class=form-control ng-model=vm.user.username required> <span ng-show=\"form.username.$dirty && form.username.$error.required\" class=help-block>Username is required</span></div><div class=form-group ng-class=\"{ \'has-error\': form.password.$dirty && form.password.$error.required }\"><label for=password>Password</label><input type=password name=password id=password class=form-control ng-model=vm.user.password required> <span ng-show=\"form.password.$dirty && form.password.$error.required\" class=help-block>Password is required</span></div><div class=form-actions><button type=submit ng-disabled=\"form.$invalid || vm.dataLoading\" class=\"btn btn-primary\">Register</button> <img ng-if=vm.dataLoading src=\"data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==\"> <a href=#/login class=\"btn btn-link\">Cancel</a></div></form></div>");
$templateCache.put("app/components/sidebarModal/sidebarModal.html","<div class=sbp-modal-dialog><div class=modal-content sbp-modal-transclude></div></div><!--{{size ? \'modal-\' + size : \'\'}}-->");
$templateCache.put("app/views/init/init.html","");
$templateCache.put("app/components/paperInput_bak/paperInput.html","<div class=\"pi-container pi-label-move\" ng-class=\"[{\'pi-error\': errors == true}, {\'pi-disabled\': disabled == true}]\"><input ng-attr-name={{name}} ng-attr-step={{step}} type=text pattern={{patterna}} ng-required=getRequired() ng-model=value ng-change=onChange() ng-focus=onFocus() ng-keydown=onKeyDown($event) ng-blur=onBlur() class=pi-input ng-class=\"[{\'pi-done\': errors==false}, {\'form-control\': isSelect==true}]\" uib-typeahead=\"item.namn for item in choices | filter:$viewValue | limitTo:8\" typeahead-on-select=\"onSelect($item, $model, $label)\" autocomplete={{autocomplete}}> <span class=pi-label ng-bind-html=label></span> <span class=pi-done ng-if=\"errors == false\"></span></div><!--ng-attr-type=\'{{type}}\'--> <!--ng-keydown=\'onKeyDown($event)\'-->");
$templateCache.put("app/components/paperSelectInput/paperSelectInput.html","<div class=psi-container ng-class=\"{\'psi-disabled\': disabled == true}\"><input type=text class=psi-input readonly value={{value}}><ul class=psi-choses ng-style=\"{\'top\':chosenTop}\"><li ng-repeat=\"choise in choices\" ng-click=\"onChose($event, choise, $index)\" data-choice={{choice[1]}}>{{choise[0]}}</li></ul></div>");
$templateCache.put("app/views/print/print.html","<button class=\"floating-button floating-button-left-top floating-button-back\" ui-sref=main.workspace ng-show=true></button><div class=print-scope><div class=page><h1>Skogscalc</h1><h2>Kommun: {{vm.skogsbruksplan.kommun}}</h2><h3 ng-if=\"vm.params.lan > 0\">Lånebelopp: {{vm.params.lan | numberthousand}} kr</h3><h3 ng-if=\"vm.params.lan > 0 && vm.params.raenta > 0\">Ränta: {{vm.params.raenta | numberthousand}} %</h3><div class=page-panel><h2>Resultat</h2><table class=input-table><col width=10px><col width=10px><thead><tr><th>&nbsp;</th><th>&nbsp;</th><th ng-repeat=\"val in vm.intaekter.avverkning track by $index\">{{vm.year + $index }}</th></tr></thead><tbody><tr><th colspan={{vm.intaekter.avverkning.length}}>Intäkter</th></tr><tr ng-show=\"vm.intaekter.avverkningTot != 0\"><th>&nbsp;</th><th colspan={{vm.intaekter.avverkning.length}}>Slutavverkning</th></tr><tr ng-show=\"vm.intaekter.avverkningTot != 0\"><th>&nbsp;</th><th>&nbsp;</th><td ng-repeat=\"val in vm.intaekter.avverkning track by $index\">{{val | numbershort : \'kr\'}}</td></tr><tr ng-show=\"vm.intaekter.gallring != 0\"><th>&nbsp;</th><th colspan={{vm.intaekter.avverkning.length}}>Gallring</th></tr><tr ng-show=\"vm.intaekter.gallring != 0\"><th>&nbsp;</th><th>&nbsp;</th><td colspan={{vm.intaekter.avverkning.length}}>{{vm.intaekter.gallring | numbershort : \'kr\'}}</td></tr><tr><th colspan={{vm.intaekter.avverkning.length}}>Kostnader</th></tr><tr ng-show=\"vm.kostnader.lan != 0\"><th>&nbsp;</th><th colspan={{vm.intaekter.avverkning.length}}>Lån</th></tr><tr ng-show=\"vm.kostnader.lan != 0\"><th>&nbsp;</th><th>&nbsp;</th><td ng-repeat=\"val in vm.kostnader.aterbeskogning track by $index\">{{vm.kostnader.lan | numbershort : \'kr\'}}</td></tr><tr ng-show=\"vm.kostnader.aterbeskogningTot != 0\"><th>&nbsp;</th><th colspan={{vm.intaekter.avverkning.length}}>Återbeskogning</th></tr><tr ng-show=\"vm.kostnader.aterbeskogningTot != 0\"><th>&nbsp;</th><th>&nbsp;</th><td ng-repeat=\"val in vm.kostnader.aterbeskogning track by $index\">{{val | numbershort : \'kr\'}}</td></tr><tr ng-show=\"vm.kostnader.rojning != 0\"><th>&nbsp;</th><th colspan={{vm.intaekter.avverkning.length}}>Röjning</th></tr><tr ng-show=\"vm.kostnader.rojning != 0\"><th>&nbsp;</th><th>&nbsp;</th><td colspan={{vm.intaekter.avverkning.length}}>{{vm.kostnader.rojning | numbershort : \'kr\'}}</td></tr><tr><th colspan={{vm.intaekter.avverkning.length}}>Summa</th></tr><tr><th>&nbsp;</th><th>&nbsp;</th><td ng-repeat=\"val in vm.sum track by $index\">{{val | numbershort : \'kr\'}}</td></tr></tbody></table></div><div class=page-panel><h2>Skogsbruksplan</h2><table class=input-table><col width=10%><thead><tr><th>&nbsp;</th><th ng-repeat=\"val in vm.aldersdata\">{{val}}</th></tr></thead><tbody><tr><th>Areal<br>(ha)</th><td ng-repeat=\"val in vm.skogsbruksplan.data track by $index\">{{val.hektar || \"\"}}</td></tr><tr><th>Volym<br>(m<sup>3</sup>sk)</th><td ng-repeat=\"val in vm.skogsbruksplan.data track by $index\">{{val.m3sk || \"\"}}</td></tr></tbody></table></div></div><div class=page><div class=chart-container><div class=chart id=chart_resultat></div></div><div class=chart-container><div class=chart id=chart_skog></div></div><div class=chart-container><div class=chart id=chart_sbp></div></div></div></div>");
$templateCache.put("app/views/sbp/sbp.html","<hr><form name=vm.sbpForm class=sbp-form ng-submit=vm.submit() novalidate><!--\n    <div class=\"row\" ng-show=\"vm.hasDoneFastighet\" style=\"margin-bottom:20px;\">\n        <div class=\"col-xs-6 col-xs-offset-3\">\n            <div class=\"paper\">\n                <h3>Fastigheten redan gjord</h3>\n                <p>\n                    Fastigheten kan endast defineras en gång per kalkyl. Vänligen skapa en ny kalkyl för att beräkna på en ny fastighet.\n                </p>\n            </div>\n        </div>\n    </div>\n\n\n    <div class=\"center-text\">\n        <span class=\"action-button action-button-highcontrast action-button-small centering-container\" ng-click=\"vm.cancel()\">\n            <span class=\"centering-content\">Avbryt</span>\n        </span>\n    </div>\n--><div class=info-wrapper><div class=info-content><h3>1. Fastigheten</h3></div><!--\n        <span class=\"info-hover\"></span>\n        <div class=\"info-box info-box-top-left\">\n            <p>\n                På en sida i skogsbruksplanen finns skogens fördelning på åldersklasser/ålderskategorier.\n                Där finns uppgifter Du behöver här.\n            </p>\n        </div>\n        --><p>För att beskriva fastighetens skogsbestånd finns en skogsbruksplan. Var god och fyll i skogsbruksplanen för fastigheten du vill analysera.</p></div><div class=row><div class=\"col-xs-12 col-md-6 col-lg-6\"><div class=info-wrapper><div class=info-content><div class=form-group ng-class=\"((vm.sbpForm.kommun.$error.required || vm.sbpForm.kommun.$invalid) && vm.sbpForm.kommun.$touched) ? \'has-error has-feedback\' : \'\'\"><label for=kommun>Kommun</label><input type=text class=form-control id=kommun name=kommun ng-model=vm.form.kommun uib-typeahead=\"item.namn for item in vm.kommuner | xpTypeaheadFilter:$viewValue | limitTo:8\" required ng-change=\"vm.contains(vm.form.kommun) ? vm.sbpForm.kommun.$invalid = false : vm.sbpForm.kommun.$invalid = true\"> <span class=control-label ng-show=\"vm.sbpForm.kommun.$error.required && vm.sbpForm.kommun.$touched\">En kommun måste anges.</span> <span class=control-label ng-show=\"vm.sbpForm.kommun.$touched && vm.sbpForm.kommun.$invalid && !vm.sbpForm.kommun.$error.required\">Var god och välj en befintlig svensk kommun.</span></div></div></div></div><div class=\"col-xs-12 col-md-6 col-lg-6\"><div class=info-wrapper><div class=info-content><div class=form-group><label for=kommun>Fastighetsbeteckning</label><input type=text class=form-control id=namn name=namn ng-model=vm.SBPName></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><div class=info-wrapper><div class=info-content><div class=form-group ng-class=\"((vm.sbpForm.datumGjord.$error.required || vm.sbpForm.datumGjord.$error.max || vm.sbpForm.datumGjord.$error.min) && vm.sbpForm.datumGjord.$touched) ? \'has-error has-feedback\' : \'\'\"><label for=datumGjord>Skogsbruksplanen upprättad år</label><input class=form-control type=number id=datumGjord name=datumGjord ng-model=vm.form.datumGjord step=0.01 min=1980 max=\"{{ vm.currentYear }}\" required> <span class=control-label ng-show=\"vm.sbpForm.datumGjord.$error.required && vm.sbpForm.datumGjord.$touched\">Året skogsbruksplanen upprättades måste anges.</span> <span class=control-label ng-show=\"!vm.sbpForm.datumGjord.$error.required && vm.sbpForm.datumGjord.$touched && vm.sbpForm.datumGjord.$error.min\">Året skogsbruksplanen upprättades får inte vara tidigare än 1980.</span> <span class=control-label ng-show=\"!vm.sbpForm.datumGjord.$error.required && vm.sbpForm.datumGjord.$touched && vm.sbpForm.datumGjord.$error.max\">Året skogsbruksplanen upprättades kan inte vara senare än {{ vm.currentYear }}.</span><!--\n                            <span class=\"control-label\" ng-show=\"vm.sbpForm.kommun.$touched && vm.sbpForm.kommun.$invalid && !vm.sbpForm.kommun.$error.required\">Var god och välj en befintlig svensk kommun.</span>\n--></div><!--<pre>{{ vm.sbpForm.datumGjord | json }}</pre>--><!--                        Skogsbruksplanen upprättad år\n                        <paper-input name=\"datumGjord\" ng-model=\"vm.form.datumGjord\" required=\"true\" label=\"\" pattern=\"\\d{4}\" type=\"text\"></paper-input>\n                        <span ng-show=\"vm.sbpForm.datumGjord.$error.required && vm.sbpForm.datumGjord.$touched\" class=\"error-msg\">Ett årtal måste anges.</span>\n                        <span ng-show=\"vm.sbpForm.datumGjord.$error.serverMessage\">{{vm.sbpForm.datumGjord.$error.serverMessage}}</span>--></div><!--\nF\n                    --></div></div><div class=\"col-xs-12 col-md-6\"><div class=info-wrapper><div class=info-content><div class=form-group ng-class=\"((vm.sbpForm.bonitet.$error.required || vm.sbpForm.bonitet.$error.max || vm.sbpForm.bonitet.$error.min) && vm.sbpForm.bonitet.$touched) ? \'has-error has-feedback\' : \'\'\"><label for=bonitet>Medelbonitet</label><input type=number step=0.01 class=form-control id=bonitet name=bonitet ng-model=vm.form.bonitet min=0 max=16 required> <span class=control-label ng-show=\"vm.sbpForm.bonitet.$error.required && vm.sbpForm.bonitet.$touched\">Medelboniteten för fastigheten måste anges. Det är vanligen ett värde mellan 2-15 m<sup>3</sup>sk/ha/år.</span> <span class=control-label ng-show=\"!vm.sbpForm.bonitet.$error.required && vm.sbpForm.bonitet.$touched && vm.sbpForm.bonitet.$error.min\">Medelboniteten måste vara ett värde mellan 0-16 m<sup>3</sup>sk/ha/år.</span> <span class=control-label ng-show=\"!vm.sbpForm.bonitet.$error.required && vm.sbpForm.bonitet.$touched && vm.sbpForm.bonitet.$error.max\">Medelboniteten måste vara ett värde mellan 0-16 m<sup>3</sup>sk/ha/år.</span><!--\n                            <span class=\"control-label\" ng-show=\"vm.sbpForm.kommun.$touched && vm.sbpForm.kommun.$invalid && !vm.sbpForm.kommun.$error.required\">Var god och välj en befintlig svensk kommun.</span>\n--> <span class=unit>m<sup>3</sup>sk/ha/år</span></div><!--                        Medelbonitet\n                        <paper-input name=\"bonitet\" ng-model=\"vm.form.bonitet\" required=\"true\" label=\"\" type=\"number\" step=\"0.01\" unit=\"m<sup>3</sup>sk/ha/år\" ></paper-input>\n                        <span ng-show=\"vm.sbpForm.bonitet.$error.required  && vm.sbpForm.bonitet.$touched\" class=\"error-msg\">Bonitet måste anges.</span>\n                        <span ng-show=\"vm.sbpForm.bonitet.$error.serverMessage\">{{vm.sbpForm.bonitet.$error.serverMessage}}</span>--></div><!--\n                    <span class=\"info-hover\"></span>\n                    <div class=\"info-box info-box-top-right\">\n                        <h4>Medelbonitetsvärde</h4>\n                        <p>\n                            I skogsbruksplanen finns fastighetens <b>medelbonitet</b> angiven. Det är vanligen ett värde mellan 2 - 15 m<sup>3</sup>sk/ha/år.\n                        </p>\n                    </div>\n                    --></div></div></div><hr><div class=info-wrapper><div class=info-content><h3>2. Skogsbruksplan</h3></div><!--\n        <span class=\"info-hover\"></span>\n        <div class=\"info-box info-box-top-left\">\n            <p>\n                På en sida i skogsbruksplanen finns skogens fördelning på åldersklasser/ålderskategorier.\n                Där finns uppgifter Du behöver här.\n            </p>\n        </div>\n        --></div><table class=input-table><col width=22%><col width=auto><col width=auto><col width=18%><thead><tr><th valign=top><p>År</p></th><th valign=top><p>Areal (ha)</p></th><th valign=top><p>Volym (m<sup>3</sup>sk)</p></th><!--\n                <th valign=\"top\">\n                    <div class=\"info-wrapper\">\n                        <div class=\"info-content\">\n                            <b><p>Areal (ha)</p></b>\n                        </div>\n                        <span class=\"info-hover\"></span>\n                        <div class=\"info-box info-box-top-left\">\n                            <p>\n                                Totala arealen per åldersklass fyller Du i här.\n                            </p>\n                        </div>\n                    </div>\n                </th>\n                <th valign=\"top\">\n                    <div class=\"info-wrapper\">\n                        <div class=\"info-content\">\n                            <b><p>Volym (m<sup>3</sup>sk)</p></b>\n                        </div>\n                        <span class=\"info-hover\"></span>\n                        <div class=\"info-box info-box-top-left\">\n                            <p>\n                                Totala volymen per åldersklass fyller Du i här.\n                            </p>\n                        </div>\n                    </div>\n                </th>\n                --><th valign=top><p>Volym/ Areal</p></th></tr></thead><tbody><tr ng-repeat=\"item in vm.form.data\" ng-form=data-{{$index}}><th ng-if=\"$index != vm.form.data.length-2\"><p>{{vm.aldersdata[$index]}}</p></th><th ng-if=\"($index == vm.form.data.length-2) && !vm.hasDoneFastighet\"><p>{{vm.aldersdata[$index]}}</p></th><th ng-if=\"($index == vm.form.data.length-2) && vm.hasDoneFastighet\"><p>{{vm.aldersdata[$index]}}/Fröträd</p></th><td><div ng-class=\"((vm.sbpForm[\'data-{{$index}}\'].hektar.$error.min) ? \'has-error has-feedback\' : \'\')\"><input name=hektar ng-model=item.hektar type=number step=0.01 ng-change=vm.onDataChange(item.hektar) class=form-control min=0></div><!--<paper-input name=\"hektar\" ng-model=\"item.hektar\" ng-disabled=\"vm.hasDoneFastighet\" type=\"number\" step=\"0.01\" ng-change=\"vm.onDataChange(item.hektar)\" unit=\"ha\"></paper-input>--><!--<paper-input name=\"hektar\" ng-model=\"item.hektar\" ng-disabled=\"vm.hasDoneFastighet\" type=\"number\" step=\"0.01\" ng-change=\"vm.onDataChange(item.hektar)\"></paper-input>--><!--\n                    <span ng-show=\"vm.sbpForm.data-{{$index}}.hektar.$error.required\">You must enter a value here</span>\n                    <span ng-show=\"vm.sbpForm.data-{{$index}}.hektar.$error.serverMessage\">{{vm.sbpForm.data-$index.hektar.$error.serverMessage}}</span>\n                    --></td><td ng-if=\"$index != 0\"><div ng-class=\"((vm.sbpForm[\'data-{{$index}}\'].m3sk.$error.min) ? \'has-error has-feedback\' : \'\')\"><input name=m3sk ng-model=item.m3sk type=number step=0.01 ng-change=vm.onDataChange(item.m3sk) class=form-control min=0></div><!--<paper-input name=\"m3sk\" ng-model=\"item.m3sk\" ng-disabled=\"vm.hasDoneFastighet\" type=\"number\" step=\"0.01\" ng-change=\"vm.onDataChange(item.m3sk)\" unit=\"m<sup>3</sup>sk\"></paper-input>--><!--<paper-input name=\"m3sk\" ng-model=\"item.m3sk\" ng-disabled=\"vm.hasDoneFastighet\" type=\"number\" step=\"0.01\" ng-change=\"vm.onDataChange(item.m3sk)\"></paper-input>--><!--\n                    <span ng-show=\"vm.sbpForm.data-{{$index}}.m3sk.$error.required\">You must enter a value here</span>\n                    <span ng-show=\"vm.sbpForm.data-{{$index}}.m3sk.$error.serverMessage\">{{vm.sbpForm.data-$index.m3sk.$error.serverMessage}}</span>\n                    --></td><td ng-if=\"$index != 0\"><p>{{item.m3sk / item.hektar | number:0 }} m<sup>3</sup>sk/ha</p></td></tr><tr><th><p><button popover-placement=top-right uib-popover=\"Här skriver du in värdena som finns under kategorin Fröträd/Skikt.\" type=button class=\"tooltip-q btn btn-sm btn-add pull-right\" popover-trigger=\"mouseenter outsideClick\">?</button> Fröträd</p><!--\n                    <div class=\"info-wrapper\">\n                        <div class=\"info-content\">\n                            <p>Fröträd</p>\n                        </div>\n                        <span class=\"info-hover\"></span>\n                        <div class=\"info-box info-box-top-right\">\n                            <p>\n                                Här skriver du in värdena som finns under kategorin Fröträd/Skikt.\n                            </p>\n                        </div>\n                    </div>\n                    --></th><td><div ng-class=\"((vm.sbpForm.hektar.$error.min) ? \'has-error has-feedback\' : \'\')\"><input name=hektar id=hektar ng-model=vm.frotrad.hektar type=number step=0.01 class=form-control min=0></div><!--<paper-input name=\"hektar\" ng-model=\"vm.frotrad.hektar\" ng-disabled=\"vm.hasDoneFastighet\" type=\"number\" step=\"0.01\"></paper-input>--></td><td><div ng-class=\"((vm.sbpForm.m3sk.$error.min) ? \'has-error has-feedback\' : \'\')\"><input name=m3sk id=m3sk ng-model=vm.frotrad.m3sk type=number step=0.01 class=form-control min=0></div><!--<paper-input name=\"m3sk\" ng-model=\"vm.frotrad.m3sk\" ng-disabled=\"vm.hasDoneFastighet\" type=\"number\" step=\"0.01\"></paper-input>--></td><td><p>{{vm.frotrad.m3sk / vm.frotrad.hektar | number:0 }} m<sup>3</sup>sk/ha</p></td></tr><tr><th><p>Summa:</p></th><td><input type=number ng-model=vm.sumAreal class=form-control ng-disabled=true></td><td><input type=number ng-model=vm.sumVolym class=form-control ng-disabled=true></td></tr></tbody></table><div class=\"has-error has-feedback\"><span class=control-label ng-show=\"!vm.aldersdataValid || (vm.sbpForm.m3sk.$error.min) || (vm.sbpForm.hektar.$error.min)\">Hektar och Volym kan inte vara negativa tal.</span></div><!-- ng-show=\"vm.form.datumGjord < vm.currentYear\" --><hr><div class=info-wrapper><div class=info-content><h3>3. Alternativ</h3></div><!--\n        <span class=\"info-hover\"></span>\n        <div class=\"info-box info-box-top-left\">\n            <p>\n                På en sida i skogsbruksplanen finns skogens fördelning på åldersklasser/ålderskategorier.\n                Där finns uppgifter Du behöver här.\n            </p>\n        </div>\n        --></div><div><div class=info-wrapper><h5>Räkna upp?<label class=\"android-checkbox centering-right\"><input type=checkbox ng-model=vm.form.uppraeknad ng-disabled=\"(vm.form.datumGjord >= vm.currentYear) || (vm.form.datumGjord === undefined) \"><span></span></label></h5><p>Är skogsbruksplanen inte gjord i år? Här kan du räkna fram din skogsbruksplans tillväxt till innevarande år.</p></div></div><hr><div class=action-button-item ng-click=vm.submit($event)>Gå vidare</div><!--\n    <action-button ng-show=\"vm.isLoading == false\" text=\"Spara\" text-confirm=\"Fortsätt\" text-cancel=\"Avbryt\" on-confirm=\"vm.submit($event)\" on-before-confirm-check=\"vm.checkValid()\" text-confirm-info=\"Värdena kan inte ändras sedan, är du säker?\"></action-button>\n    --><div class=center-text ng-show=vm.isLoading style=height:70px><!--ng-show=\"vm.isLoading == true\"--><loading-spinner enabled size=50></loading-spinner></div></form>");
$templateCache.put("app/views/sbp/sbp_bak.html","<form name=vm.sbpForm ng-submit=vm.submit() novalidate><div class=row ng-show=vm.hasDoneFastighet><div class=\"col-xs-6 col-xs-offset-3\"><div class=\"panel panel-paper panel-paper-float sbp-modal-container\"><div class=panel-heading><h3 class=panel-title>Fastigheten redan gjord</h3></div><div class=\"panel-body row-spacing\"><p>Fastigheten kan endast defineras en gång per kalkyl. Vänligen skapa en ny kalkyl för att beräkna på en ny fastighet.</p></div></div></div></div><div class=\"panel panel-paper panel-paper-float sbp-modal-container\"><div class=panel-heading><h2 class=panel-title>Fastigheten</h2></div><div class=\"panel-body row-spacing\"><p>För att beskriva fastighetens skogsbestånd finns en skogsbruksplan. Var god och fyll i skogsbruksplanen för fastigheten Du vill analysera.</p><div class=row><div class=\"col-xs-12 col-md-8 col-lg-6\"><div class=info-wrapper><div class=info-content><paper-input name=kommun ng-model=vm.form.kommun ng-disabled=vm.hasDoneFastighet required label=\"Skriv in kommun\" choices=vm.kommuner></paper-input><span ng-show=vm.sbpForm.kommun.$error.required>En kommun måste anges.</span> <span ng-show=vm.sbpForm.kommun.$error.serverMessage>{{vm.sbpForm.kommun.$error.serverMessage}}</span></div><span class=info-hover></span><div class=\"info-box info-box-top-left\"><h4>Kommun</h4><p>Skriv in den <b>kommun</b> där fastigheten är belägen.</p></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><div class=info-wrapper><div class=info-content><paper-input name=datumGjord ng-model=vm.form.datumGjord ng-disabled=vm.hasDoneFastighet required label=\"Skapad år: (ex. 2014)\" pattern=\\d{4}></paper-input><span ng-show=vm.sbpForm.datumGjord.$error.required>Ett årtal måste anges.</span> <span ng-show=vm.sbpForm.datumGjord.$error.serverMessage>{{vm.sbpForm.datumGjord.$error.serverMessage}}</span></div><span class=info-hover></span><div class=\"info-box info-box-top-left\"><h4>År upprättad</h4><p>Skriv in det <b>år</b> skogsbruksplanen är upprättad.</p></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=info-wrapper><div class=info-content><paper-input name=bonitet ng-model=vm.form.bonitet ng-disabled=vm.hasDoneFastighet required label=Bonitet: type=number step=0.01 unit=\"m<sup>3</sup>sk/ha/år\"></paper-input><span ng-show=vm.sbpForm.bonitet.$error.required>You must enter a value here</span> <span ng-show=vm.sbpForm.bonitet.$error.serverMessage>{{vm.sbpForm.bonitet.$error.serverMessage}}</span></div><span class=info-hover></span><div class=\"info-box info-box-top-left\"><h4>Medelbonitetsvärde</h4><p>I skogsbruksplanen finns fastighetens <b>medelbonitet</b> angiven. Det är vanligen ett värde mellan 2 - 15 m<sup>3</sup>sk/ha/år.</p></div></div></div></div></div></div><div class=\"panel panel-paper panel-paper-float sbp-modal-container\"><div class=panel-heading><h3 class=panel-title>Skogsbruksplan</h3></div><div class=panel-body><table class=input-table><col width=15%><col width=auto><col width=auto><col width=15%><thead><tr><td><div class=info-wrapper><div class=info-content><b>Ålerskalasser</b></div><span class=info-hover></span><div class=\"info-box info-box-top-right\"><p>På en sida i skogsbruksplanen finns skogens fördelning på åldersklasser/ålderskategorier. Där finns uppgifter Du behöver här.</p></div></div></td><td><div class=info-wrapper><div class=info-content><b>Areal (ha)</b></div><span class=info-hover></span><div class=\"info-box info-box-top-left\"><p>Totala arealen per åldersklass fyller Du i här.</p></div></div></td><td><div class=info-wrapper><div class=info-content><b>Volym (m<sup>3</sup>sk)</b></div><span class=info-hover></span><div class=\"info-box info-box-top-left\"><p>Totala volymen per åldersklass fyller Du i här.</p></div></div></td><th>Volym/Area</th></tr></thead><tbody><tr ng-repeat=\"item in vm.form.data\" ng-form=data-{{$index}}><th>{{vm.aldersdata[$index]}}</th><td><paper-input name=hektar ng-model=item.hektar ng-disabled=vm.hasDoneFastighet type=number step=0.01 ng-change=vm.onDataChange(item.hektar) unit=ha></paper-input><!--\n                            <span ng-show=\"vm.sbpForm.data-{{$index}}.hektar.$error.required\">You must enter a value here</span>\n                            <span ng-show=\"vm.sbpForm.data-{{$index}}.hektar.$error.serverMessage\">{{vm.sbpForm.data-$index.hektar.$error.serverMessage}}</span>\n                            --></td><td><paper-input name=m3sk ng-model=item.m3sk ng-disabled=vm.hasDoneFastighet type=number step=0.01 ng-change=vm.onDataChange(item.m3sk) unit=\"m<sup>3</sup>sk\"></paper-input><!--\n                            <span ng-show=\"vm.sbpForm.data-{{$index}}.m3sk.$error.required\">You must enter a value here</span>\n                            <span ng-show=\"vm.sbpForm.data-{{$index}}.m3sk.$error.serverMessage\">{{vm.sbpForm.data-$index.m3sk.$error.serverMessage}}</span>\n                            --></td><td>{{item.m3sk / item.hektar | number:0 }} m<sup>3</sup>sk/ha</td></tr><tr><th>Summa:</th><td><paper-input type=number ng-model=vm.sumAreal ng-disabled=true unit=ha></paper-input></td><td><paper-input type=number ng-model=vm.sumVolym ng-disabled=true unit=\"m<sup>3</sup>sk\"></paper-input></td></tr></tbody></table></div></div><input class=\"btn btn-primary\" type=submit name=submit></form>");
$templateCache.put("app/views/start/start.html","<!--\n<div id=\"startContainer\" class=\"loading-controller dimmable full-size full-image full-image-darken high-contrast centering-container\" style=\"background-image: url(\'assets/images/forest.jpg\')\">\n--><div id=startContainer class=\"loading-controller full-size\"><div class=\"col-xs-12 col-md-6 col-md-push-3\"><div class=\"centering-content loading-overlay\"><div class=\"panel panel-paper\"><!-- LOGO --><div class=\"logo-container panel-heading clearfix\"><img src=assets/images/FORESTA_logo_symbol_farg.svg class=logo-img><p class=logo-txt>SkogsCALC</p></div><!--                <div class=\"logo-container panel-heading clearfix\">\n                    <p>Välkommen till SkogsCALC!</p>\n                </div>--><!--<hr />--><!-- HEADER --><div class=panel-body style=\"margin-bottom: 0px\"><p>Välkommen till SkogsCALC.<br>Planerar Du att köpa skog eller ta över en skogsfastighet som finns i släkten?<br>Eller är Du bara nyfiken på hur skogsägarens ekonomi kan se ut?<br><br>Med SkogsCALC så får Du svar på vilken ekonomi en viss skogsfastighet har och en prognos på värdeförändringen de kommande 10 åren.</p></div><div class=panel-heading><h2 class=panel-title>Ny Kalkyl</h2></div><div class=panel-body><div id=sbpinject></div></div></div></div><!--<div class=\"loading-spinner\"></div>--></div></div>");
$templateCache.put("app/views/workspace/modalWindowTemplate.html","<div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=modal-content uib-modal-transclude></div></div>");
$templateCache.put("app/views/workspace/workspace.html","<div class=\"content-container workspace-scope\"><div class=\"row side-navbar-container\" ng-class=\"{\'dimmed-workspace\': vm.hasDoneFastighet == false}\"><!--<div id=\"workspace\" class=\"col-xs-6 col-md-7 col-lg-9 col-xl-10\" style=\"padding-top:20px;\">--><!--<div id=\"workspace\" class=\"col-xs-6\" style=\"padding-top:20px; display:none;\">--><div id=workspace class=\"col-xs-6 col-md-7 col-lg-9 col-xl-10\" style=padding-top:20px><div class=row><div class=\"col-xs-12 col-xs-offset-0 col-md-12 col-sm-offset-0 col-md-12 col-md-offset-0 col-lg-12 col-lg-offset-0 col-xl-10 col-xl-offset-1\"><div class=\"panel panel-paper\"><div class=panel-heading><h2 class=panel-title>Resultat</h2></div><div class=\"panel-body row-spacing\"><table class=input-table><col width=10px><col width=10px><thead><tr><th>&nbsp;</th><th>&nbsp;</th><th ng-repeat=\"val in vm.intaekter.avverkning track by $index\">{{vm.year + $index }}</th></tr></thead><tbody><tr><th colspan={{vm.intaekter.avverkning.length}}>Intäkter</th></tr><tr ng-show=\"vm.intaekter.avverkningTot != 0\"><th>&nbsp;</th><th colspan={{vm.intaekter.avverkning.length}}>Slutavverkning</th></tr><tr ng-show=\"vm.intaekter.avverkningTot != 0\"><th>&nbsp;</th><th>&nbsp;</th><td ng-repeat=\"val in vm.intaekter.avverkning track by $index\">{{val | numbershort : \'kr\'}}</td></tr><tr ng-show=\"vm.intaekter.gallring != 0\"><th>&nbsp;</th><th colspan={{vm.intaekter.avverkning.length}}>Gallring</th></tr><tr ng-show=\"vm.intaekter.gallring != 0\"><th>&nbsp;</th><th>&nbsp;</th><td colspan={{vm.intaekter.avverkning.length}}>{{vm.intaekter.gallring | numbershort : \'kr\'}}</td></tr><tr><th colspan={{vm.intaekter.avverkning.length}}>Kostnader</th></tr><tr ng-show=\"vm.kostnader.lan != 0\"><th>&nbsp;</th><th colspan={{vm.intaekter.avverkning.length}}>Lån</th></tr><tr ng-show=\"vm.kostnader.lan != 0\"><th>&nbsp;</th><th>&nbsp;</th><td ng-repeat=\"val in vm.kostnader.aterbeskogning track by $index\">{{vm.kostnader.lan | numbershort : \'kr\'}}</td></tr><tr ng-show=\"vm.kostnader.aterbeskogningTot != 0\"><th>&nbsp;</th><th colspan={{vm.intaekter.avverkning.length}}>Återbeskogning</th></tr><tr ng-show=\"vm.kostnader.aterbeskogningTot != 0\"><th>&nbsp;</th><th>&nbsp;</th><td ng-repeat=\"val in vm.kostnader.aterbeskogning track by $index\">{{val | numbershort : \'kr\'}}</td></tr><tr ng-show=\"vm.kostnader.rojning != 0\"><th>&nbsp;</th><th colspan={{vm.intaekter.avverkning.length}}>Röjning</th></tr><tr ng-show=\"vm.kostnader.rojning != 0\"><th>&nbsp;</th><th>&nbsp;</th><td colspan={{vm.intaekter.avverkning.length}}>{{vm.kostnader.rojning | numbershort : \'kr\'}}</td></tr><tr><th colspan={{vm.intaekter.avverkning.length}}>Summa</th></tr><tr><th>&nbsp;</th><th>&nbsp;</th><td ng-repeat=\"val in vm.sum track by $index\">{{val | numbershort : \'kr\' }}</td></tr></tbody></table></div></div><div class=\"resp-col-container resp-col-xs-1 resp-col-sm-1 resp-col-md-1 resp-col-lg-2 resp-col-xl-2\"><!--\n					<div class=\"resp-col\">\n						<div class=\"panel panel-paper\">\n							<div class=\"panel-heading\">\n								<h2 class=\"panel-title\">Förvärvslikviditet</h2>\n							</div>\n							<div class=\"panel-body row-spacing\">\n							<table class=\"input-table\">\n						        <thead>\n						            <tr>\n						            </tr>\n						        </thead>\n						        <tbody>\n						            <tr>\n						            </tr>\n						        </tbody>\n						    </table>\n							</div>\n						</div>\n					</div>\n					--><div class=resp-col><div class=\"panel panel-paper\"><div class=panel-heading><h2 class=panel-title>Resultat</h2></div><div class=panel-body><div id=chart_resultat class=chart></div></div></div></div><div class=resp-col><div class=\"panel panel-paper\"><div class=panel-heading><h2 class=panel-title>Skogsförråd</h2></div><div class=panel-body><div id=chart_skog class=chart></div></div></div></div><div class=resp-col><div class=\"panel panel-paper\"><div class=panel-heading><h2 class=panel-title>Skogsbruksplan</h2></div><div class=panel-body><div id=chart_sbp class=chart></div></div></div></div></div></div></div><button class=\"floating-button floating-button-left-bottom floating-button-print\" ui-sref=print ng-show=\"vm.hasDoneFastighet && vm.hasDoneParams && !vm.isloading\"></button></div><div id=workspace-dimmer ng-show=\"!vm.hasDoneFastighet || vm.isloading || vm.showSbp\"><div class=\"col-xs-6 col-md-7 col-lg-9 col-xl-10\" style=height:100%><loading-spinner enabled label=laddar....></loading-spinner></div></div><!--<div id=\"navbar\" class=\"side-navbar col-xs-6 col-md-5 col-lg-3 col-xl-2\">--><!--\n	<div id=\"navbar-switcher\" class=\"col-xs-9 col-xs-offset-3\"\n			ng-show=\"vm.showSbp\"\n			animation-callback=\"vm.sbpanimated\">\n			animated-if=\"vm.showSbp\" \n			animated-if-leave-callback=\"vm.showSbpLeaveDone()\"\n			animated-if-enter-callback=\"vm.showSbpEnterDone()\"\n		<div id=\"navbar-switcher-content\" id=\"sbpinject\"></div>\n	</div>\n	--><div class=\"col-xs-6 col-md-5 col-lg-3 col-xl-2\"><div id=navbar-switcher ng-show=vm.showSbp animation-callback=vm.sbpanimated><div id=navbar-switcher-content class=paper><div id=sbpinject></div></div></div><div id=navbar class=\"side-navbar paper\" ng-show=vm.showNavigation animation-callback=vm.navigationanimated><div id=info-1 class=side-navbar-row><div class=side-navbar-info ng-show=!vm.hasDoneFastighet><h4>Hej och välkommen!</h4><p>Börja med att skriva in fastigheten. Klicka på knappen \"Fastighet\" för att gå vidare.</p></div><div class=center-text><span class=\"action-button action-button-highcontrast action-button-small centering-container\" ng-click=\"vm.open(\'lg\')\"><span class=centering-content>Fastighet</span></span></div><h4>Räkna upp?<label class=\"android-checkbox centering-right\"><input type=checkbox ng-model=vm.raknaupp ng-disabled=!vm.hasDoneFastighet><span></span></label></h4><p>Räkna upp en skogsbruksplan som inte är gjord i år och låta skogen växa.</p></div><form name=vm.viewForm novalidate><div class=side-navbar-row><h4>Befintligt innehav?<label class=\"android-checkbox centering-right\"><input type=checkbox ng-model=vm.befintligt_innehav ng-disabled=!vm.hasDoneFastighet><span></span></label></h4><div ng-show=\'vm.form.forvarvstyp != \"BI\"\'><div class=info-wrapper><div class=info-content><h3>Förvärvstyp</h3></div><span class=info-hover ng-show=vm.hasDoneFastighet></span><div class=\"side-navbar-info-box info-box\"><h4>Förvärvstyp</h4><p>Ingen information.</p></div></div><paper-select-input name=forvarvstyp required ng-model=vm.form.forvarvstyp choices=\"[[\'Köp\', \'KO\'], [\'Gåva\', \'GA\'], [\'Fastighetsreglering\', \'FA\']]\" ng-disabled=!vm.hasDoneFastighet></paper-select-input></div></div><div class=side-navbar-row><div class=info-wrapper><div class=info-content><h3>Virkespris</h3></div><span class=info-hover ng-show=vm.hasDoneFastighet></span><div class=\"side-navbar-info-box info-box\"><h4>Virkespris</h4><p>Här fyller Du i priset Du får per m<sup>3</sup>fub vid slutavverkning respektive gallring. Priset är netto efter avverkningskostnader. Det förifyllda priset är ett ungefärligt pris för den aktuella kommunen. Observera att priset kan skilja mycket mellan olika trädslag, virkeskvaliteter och andra förutsättningar.</p></div></div><div class=row><div class=col-xs-6><paper-input name=virkespris_slutavverkning ng-model=vm.form.intaekt.virkespris_slutavverkning label=Slutavverkning type=number unit=\"kr/m<sup>3</sup>fub\" label-error=\"Fältet behöver vara siffror\" ng-disabled=!vm.hasDoneFastighet></paper-input></div><div class=col-xs-6><paper-input name=virkespris_gallring ng-model=vm.form.intaekt.virkespris_gallring required label=Gallring type=number unit=\"kr/m<sup>3</sup>fub\" label-error=\"Fältet behöver vara siffror\" ng-disabled=!vm.hasDoneFastighet></paper-input></div></div></div><div class=side-navbar-row><div class=info-wrapper><div class=info-content><h3>Kostnader</h3></div><span class=info-hover ng-show=vm.hasDoneFastighet></span><div class=\"side-navbar-info-box info-box\"><h4>Kostnader</h4><p>En medelkostnad för fastighetens röjning samt återbeskogning. Observera att detta anges i handelsmåttet kr/ha.</p></div></div><div class=row><div class=col-xs-6><paper-input name=rojning ng-model=vm.form.kostnad.rojning required label=Röjning type=number unit=kr/ha label-error=\"Fältet behöver vara siffror\" ng-disabled=!vm.hasDoneFastighet></paper-input></div><div class=col-xs-6><paper-input name=aterbeskogning ng-model=vm.form.kostnad.aterbeskogning required label=Återbeskogning unit=kr/ha type=number label-error=\"Fältet behöver vara siffror\" ng-disabled=!vm.hasDoneFastighet></paper-input></div></div></div><div class=side-nav-row><h3>Lån/Avkastning</h3><paper-select-input ng-model=vm.berakningsform choices=vm.berakningsformer ng-disabled=!vm.hasDoneFastighet></paper-select-input></div><div class=side-navbar-row ng-show=\"vm.berakningsform == 1\" style=margin-top:10px><div class=row><div class=col-xs-8><paper-input name=lan ng-model=vm.form.lan label=Lånesumma unit=kr type=number label-error=\"Fältet behöver vara siffror\" ng-disabled=!vm.hasDoneFastighet></paper-input></div><div class=col-xs-4><paper-input name=raenta ng-model=vm.form.raenta label=Ränta unit=% type=number label-error=\"Fältet behöver vara siffror\" ng-disabled=!vm.hasDoneFastighet></paper-input></div></div><div class=info-wrapper><div class=info-content><paper-input name=pantbrev ng-model=vm.form.pantbrev label=\"Befintligt pantbrev\" type=number unit=kr label-error=\"Fältet behöver vara siffror\" ng-disabled=!vm.hasDoneFastighet></paper-input></div><span class=info-hover ng-show=vm.hasDoneFastighet></span><div class=\"side-navbar-info-box info-box\"><h4>Pantbrevskostnad</h4><p>Om befintliga pantbrev inte täcker hela lånet tillkommer en kostnad för att ta ut nya pantbrev.</p></div></div></div><div class=side-navbar-row ng-show=\"vm.berakningsform == 2\" style=margin-top:10px><div class=info-wrapper><div class=info-content><div class=row><div class=col-xs-4><paper-input name=avkastning ng-model=vm.avkastning label=Avkastning unit=% type=number label-error=\"Fältet behöver vara siffror\" ng-disabled=!vm.hasDoneFastighet></paper-input></div><div class=col-xs-8><paper-input name=fastighetsvarde ng-model=vm.fastighetsvarde label=Fastighetsvärde unit=kr type=number label-error=\"Fältet behöver vara siffror\" ng-disabled=true></paper-input></div></div></div><span class=info-hover ng-show=vm.hasDoneFastighet></span><div class=\"side-navbar-info-box info-box\"><h4>Avkastning</h4><p>Är Du intresserad av fastighetens avkastningsmöjligheter?<br>Fyll i önskad avkastningsränta i %. Utifrån avkastingsräntan visas här vilket värde Du kan betala för fastigheten och få önskad avkastning. (*)</p></div></div></div><div class=side-navbar-row><h3>Avverkning</h3><android-checkbox name=avverkning ng-model=vm.prognosform.avverkning ac-choices=\"[[\'Inget\', 0], [\'Tillväxt\', 2], [\'Max\', 1]]\" ac-chosen=0 ng-disabled=\"!vm.hasDoneFastighet || vm.berakningsform == 2\"></android-checkbox></div></form><div class=side-navbar-row><div class=info-wrapper><div class=info-content><h3>Gallring</h3></div><span class=info-hover ng-show=vm.hasDoneFastighet></span><div class=\"side-navbar-info-box info-box\"><h4>Gallring</h4><p>Fyll här i vid vilken/vilka åldrar Du önskar gallra skogen. Om det inte finns tillräckliga virkesvolymer kommer gallringen inte att ske.</p></div></div><multiple-checkbox name=gallring ng-model=vm.prognosform.gallring choices=\"[[\'20 - 29 år\', 3], [\'30 - 39 år\', 4], [\'40 - 49 år\', 5], [\'50 - 59 år\', 6], [\'60 - 69 år\', 7], [\'70 - 79 år\', 8]]\" ng-disabled=!vm.hasDoneFastighet></multiple-checkbox></div><div class=side-navbar-row><div class=info-wrapper><div class=info-content><h3>Röjning</h3></div><span class=info-hover ng-show=vm.hasDoneFastighet></span><div class=\"side-navbar-info-box info-box\"><h4>Röjning</h4><p>Fyll här i vid vilken/vilka åldrar Du önskar röja skogen. All skog i den valda åldersklassen kommer att röjas.</p></div></div><multiple-checkbox name=rojning ng-model=\"vm.prognosform.rojning \" choices=\"[[\'0 - 9 år\', 1], [\'10 - 19 år\', 2], [\'20 - 29 år\', 3]]\" ng-disabled=!vm.hasDoneFastighet></multiple-checkbox></div></div></div></div></div>");
$templateCache.put("app/views/wspace/wspace.html","<div id=wspace><!-- TAB GROUP --><div class=\"btn-group btn-group-justified\"><label class=\"tab btn btn-default\" ng-model=vm.activeTab uib-btn-radio=0 uncheckable><i class=\"fa fa-list\" aria-hidden=true></i> Åtgärder</label><label class=\"tab btn btn-default\" ng-model=vm.activeTab uib-btn-radio=1 uncheckable><i class=\"fa fa-money\" aria-hidden=true></i> Priser</label><label class=\"tab btn btn-default\" ng-model=vm.activeTab uib-btn-radio=2 uncheckable><i class=\"fa fa-calculator\" aria-hidden=true></i> Lån & Avkastning</label><!--        <label class=\"tab btn btn-default\" ng-model=\"vm.activeTab\" uib-btn-radio=\"3\" uncheckable>\n            <i class=\"fa fa-bar-chart\" aria-hidden=\"true\"></i>\n            Resultat\n        </label>--></div><!-- COLLAPSABLE CONTENT --><div uib-collapse=vm.isCollapsed><div class=\"well well-lg\"><!-- ACTIONS CONTENT --><div ng-show=\"vm.tabs.ACTIONS === vm.activeTab\"><div class=row><div class=col-xs-12><h3>Slutavverkning</h3></div><div class=radio-content><div class=col-xs-4><input id=av_inget type=radio name=response data-ng-model=vm.actions.avverkning data-ng-value=0><label for=av_inget>Inget</label></div><div class=col-xs-4><input id=av_tillv type=radio name=response data-ng-model=vm.actions.avverkning data-ng-value=2><label for=av_tillv>Tillväxt</label></div><div class=col-xs-4><input id=av_max type=radio name=response data-ng-model=vm.actions.avverkning data-ng-value=1><label for=av_max>Max</label></div></div></div><div class=row><div class=col-xs-12><h3>Gallring</h3></div></div><div class=row><div class=\"col-xs-4 col-md-4 custom-checkbox\" ng-repeat=\"alder in [[\'20 - 29 år\', 3], [\'30 - 39 år\', 4], [\'40 - 49 år\', 5], [\'50 - 59 år\', 6], [\'60 - 69 år\', 7], [\'70 - 79 år\', 8]]\"><input id=\"{{ alder[1] }}\" type=checkbox name=gallring value={{alder[1]}} ng-checked=\"vm.actions.gallring.indexOf(alder[1]) > -1\" ng-click=toggleSelectionGal(alder[1]) ng-disabled=\"(alder[1] === 3) && (vm.actions.rojning.indexOf(alder[1]) > -1)\"><label for=\"{{ alder[1] }}\">{{ alder[0] }}</label></div></div><div class=row><div class=col-xs-12><h3>Röjning</h3><!--                        <span class=\"info-hover\"></span>\n                        <div class=\"info-box info-box-top-left\">\n                            <h4>Röjning</h4>\n                            <p>\n                                Fyll här i vid vilken/vilka åldrar Du önskar röja skogen.\n                                All skog i den valda åldersklassen kommer att röjas.\n                            </p>\n                        </div>--></div></div><div class=row><div class=\"col-xs-4 col-md-4 custom-checkbox\" ng-repeat=\"alder in [[\'0 - 9 år\', 1], [\'10 - 19 år\', 2], [\'20 - 29 år\', 3]]\"><input id=\"{{ alder[1] + \'roj\' }}\" type=checkbox name=rojning value={{alder[1]}} ng-checked=\"vm.actions.rojning.indexOf(alder[1]) > -1\" ng-click=toggleSelectionRoj(alder[1]) ng-disabled=\"(alder[1] === 3) && (vm.actions.gallring.indexOf(alder[1]) > -1)\"><label for=\"{{ alder[1] + \'roj\' }}\">{{ alder[0] }}</label></div></div></div><!-- PRICES CONTENT --><div ng-show=\"vm.tabs.PRICES === vm.activeTab\"><form name=vm.priceForm class=sbp-form novalidate><div class=row><div class=col-xs-12><h3><button popover-placement=left-bottom uib-popover=\"Här fyller Du i priset du får per m³fub vid slutavverkning respektive gallring.\n                                                            Priset är netto efter avverkningskostnader.\n                                                            Det förifyllda priset är ett ungefärligt pris för den aktuella kommunen.\n                                                            Observera att priset kan skilja mycket mellan olika trädslag, virkeskvaliteter och andra förutsättningar.\" type=button class=\"tooltip-q btn btn-sm btn-add pull-right\" popover-trigger=\"mouseenter outsideClick\">?</button> Virkespris</h3></div></div><div class=row><div class=\"col-xs-6 col-md-6\"><div class=info-wrapper><div class=info-content><div class=form-group ng-class=\"((vm.priceForm.virkespris_slutavverkning.$error.min || vm.priceForm.virkespris_slutavverkning.$error.max || vm.priceForm.virkespris_slutavverkning.$error.required) && vm.priceForm.virkespris_slutavverkning.$touched) ? \'has-error has-feedback\' : \'\'\"><label for=virkespris_slutavverkning>Slutavverkning</label><input type=number class=form-control id=virkespris_slutavverkning name=virkespris_slutavverkning ng-model=vm.prices.slutavverkning min=0 max=3000 required> <span class=unit>kr/m<sup>3</sup>fub</span></div></div></div></div><div class=\"col-xs-6 col-md-6\"><div class=info-wrapper><div class=info-content><div class=form-group ng-class=\"((vm.priceForm.virkespris_gallring.$error.min || vm.priceForm.virkespris_gallring.$error.max || vm.priceForm.virkespris_gallring.$error.required) && vm.priceForm.virkespris_gallring.$touched) ? \'has-error has-feedback\' : \'\'\"><label for=virkespris_gallring>Gallring</label><input type=number class=form-control id=virkespris_gallring name=virkespris_gallring ng-model=vm.prices.gallring min=-500 max=2000 required> <span class=unit>kr/m<sup>3</sup>fub</span></div></div></div></div></div><div class=has-error><div class=control-label ng-show=\"(vm.priceForm.virkespris_slutavverkning.$error.min || vm.priceForm.virkespris_slutavverkning.$error.max) && vm.priceForm.virkespris_slutavverkning.$touched\">Virkespriset för slutavverkning måste vara mellan 0 - 3000 kr/m<sup>3</sup>fub.</div><div class=control-label ng-show=\"vm.priceForm.virkespris_slutavverkning.$error.required && vm.priceForm.virkespris_slutavverkning.$touched\">Ett virkespris för slutavverkning måste anges.</div><div class=control-label ng-show=\"(vm.priceForm.virkespris_gallring.$error.min || vm.priceForm.virkespris_gallring.$error.max) && vm.priceForm.virkespris_gallring.$touched\">Virkespriset för gallring måste vara mellan -500 - 2000 kr/m<sup>3</sup>fub.</div><div class=control-label ng-show=\"vm.priceForm.virkespris_gallring.$error.required && vm.priceForm.virkespris_gallring.$touched\">Ett virkespris för gallring måste anges.</div></div><!--<button uib-popover=\"I appeared on mouse enter!\" popover-trigger=\"\'mouseenter\'\" type=\"button\" class=\"btn btn-default\">Mouseenter</button>--><div class=row><div class=col-xs-12><h3><button popover-placement=left-bottom uib-popover=\"En medelkostnad för fastighetens röjning samt återbeskogning. Observera att detta anges i handelsmåttet kr/ha.\" type=button class=\"tooltip-q btn btn-sm btn-add pull-right\" popover-trigger=\"mouseenter outsideClick\">?</button> Kostnader</h3></div></div><div class=row><div class=\"col-xs-6 col-md-6\"><div class=info-wrapper><div class=info-content><div class=form-group ng-class=\"((vm.priceForm.rojning.$error.min || vm.priceForm.rojning.$error.max || vm.priceForm.rojning.$error.required) && vm.priceForm.rojning.$touched) ? \'has-error has-feedback\' : \'\'\"><label for=rojning>Röjning</label><input type=number class=form-control id=rojning name=rojning ng-model=vm.prices.rojning min=0 max=20000 required> <span class=unit>kr/ha</span><!--                                        <label for=\"virkespris_slutavverkning\">Slutavverkning</label>\n                                        <input type=\"number\" class=\"form-control\"  id=\"virkespris_slutavverkning\" name=\"virkespris_slutavverkning\" ng-model=\"vm.prices.slutavverkning\" min=\"0\" max=\"3000\" required>\n                                        <span class=\"unit\">kr/m<sup>3</sup>fub</span>--></div></div></div></div><div class=\"col-xs-6 col-md-6\"><div class=info-wrapper><div class=info-content><div class=form-group ng-class=\"((vm.priceForm.aterbeskogning.$error.min || vm.priceForm.aterbeskogning.$error.max || vm.priceForm.aterbeskogning.$error.required) && vm.priceForm.aterbeskogning.$touched) ? \'has-error has-feedback\' : \'\'\"><label for=aterbeskogning>Återbeskogning</label><input type=number class=form-control id=aterbeskogning name=aterbeskogning ng-model=vm.prices.aterbeskogning min=0 max=50000 required> <span class=unit>kr/ha</span><!--                                        <label for=\"virkespris_gallring\">Gallring</label>\n                                        <input type=\"number\" class=\"form-control\"  id=\"virkespris_gallring\" name=\"virkespris_gallring\" ng-model=\"vm.prices.gallring\" min=\"-500\" max=\"2000\" required>\n                                        <span class=\"unit\">kr/m<sup>3</sup>fub</span>--></div></div></div></div></div><div class=has-error><div class=control-label ng-show=\"(vm.priceForm.rojning.$error.min || vm.priceForm.rojning.$error.max) && vm.priceForm.rojning.$touched\">Kostnaden för röjning måste vara mellan 0 - 20 000 kr/m<sup>3</sup>fub.</div><div class=control-label ng-show=\"vm.priceForm.rojning.$error.required && vm.priceForm.rojning.$touched\">En kostnad för röjning måste anges.</div><div class=control-label ng-show=\"(vm.priceForm.aterbeskogning.$error.min || vm.priceForm.aterbeskogning.$error.max) && vm.priceForm.aterbeskogning.$touched\">Kostnaden för återbeskogning måste vara mellan 0 - 50 000 kr/m<sup>3</sup>fub.</div><div class=control-label ng-show=\"vm.priceForm.aterbeskogning.$error.required && vm.priceForm.aterbeskogning.$touched\">En kostnad för återbeskogning måste anges.</div></div><!--                    <div class=\"info-wrapper\">\n                        <div class=\"info-content\">\n                            <h3><button popover-placement=\"left-bottom\"\n                                        uib-popover=\"En medelkostnad för fastighetens röjning samt återbeskogning. Observera att detta anges i handelsmåttet kr/ha.\"\n                                        type=\"button\" class=\"tooltip-q btn btn-sm btn-add pull-right\" popover-trigger=\"mouseenter outsideClick\">?</button>Kostnader</h3>\n                        </div>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"\n                            col-xs-6\n                            col-md-6\">\n                            <div class=\"info-wrapper\">\n                                <div class=\"info-content\">\n                                    <div class=\"form-group\">\n                                        <label for=\"rojning\">Röjning</label>\n                                        <input type=\"number\" class=\"form-control\"  id=\"rojning\" name=\"rojning\" ng-model=\"vm.prices.rojning\" required>\n                                        <span class=\"unit\">kr/ha</span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"\n                        col-xs-6\n                        col-md-6\">\n                            <div class=\"info-wrapper\">\n                                <div class=\"info-content\">\n                                    <div class=\"form-group\">\n                                        <label for=\"aterbeskogning\">Återbeskogning</label>\n                                        <input type=\"number\" class=\"form-control\"  id=\"aterbeskogning\" name=\"aterbeskogning\" ng-model=\"vm.prices.aterbeskogning\" required>\n                                        <span class=\"unit\">kr/ha</span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>--></form></div><!--                <div class=\"side-navbar-row\">\n                    <div class=\"info-wrapper\">\n                        <div class=\"info-content\">\n                            <h3>Virkespris</h3>\n                        </div>\n                        <span class=\"info-hover\"></span>\n                        <div class=\"info-box info-box-top-left\">\n                            <h4>Virkespris</h4>\n                            <p>\n                                Här fyller Du i priset Du får per m<sup>3</sup>fub vid slutavverkning respektive gallring.\n                                Priset är netto efter avverkningskostnader.\n                                Det förifyllda priset är ett ungefärligt pris för den aktuella kommunen.\n                                Observera att priset kan skilja mycket mellan olika trädslag, virkeskvaliteter och andra förutsättningar.\n                            </p>\n                        </div>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"col-xs-6\">\n                            Slutavverkning:\n                            <paper-input name=\"virkespris_slutavverkning\" ng-model=\"vm.prices.slutavverkning\" type=\"number\" unit=\"kr/m<sup>3</sup>fub\" label-error=\"Fältet behöver vara siffror\"></paper-input>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            Gallring:\n                            <paper-input name=\"virkespris_gallring\" ng-model=\"vm.prices.gallring\" required=\"true\" type=\"number\"  unit=\"kr/m<sup>3</sup>fub\" label-error=\"Fältet behöver vara siffror\"></paper-input>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"side-navbar-row\">\n                    <div class=\"info-wrapper\">\n                        <div class=\"info-content\">\n                            <h3>Kostnader</h3>\n                        </div>\n                        <span class=\"info-hover\"></span>\n                        <div class=\"info-box info-box-top-left\">\n                            <h4>Kostnader</h4>\n                            <p>\n                                En medelkostnad för fastighetens röjning samt återbeskogning. Observera att detta anges i handelsmåttet kr/ha.\n                            </p>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-6\">\n                            Röjning:\n                            <paper-input name=\"rojning\" ng-model=\"vm.prices.rojning\" required=\"true\" type=\"number\" unit=\"kr/ha\" label-error=\"Fältet behöver vara siffror\"></paper-input>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            Återbeskogning\n                            <paper-input name=\"aterbeskogning\" ng-model=\"vm.prices.aterbeskogning\" required=\"true\" unit=\"kr/ha\" type=\"number\" label-error=\"Fältet behöver vara siffror\"></paper-input>\n                        </div>\n                    </div>\n                </div>\n\n            </div>--><!-- COMPUTATIONS CONTENT --><div ng-show=\"vm.tabs.COMPUTATIONS === vm.activeTab\"><form name=vm.compForm class=sbp-form novalidate><div class=row><div class=col-xs-12><h3>Lån/Avkastning</h3></div></div><div class=row><div class=radio-content><div class=col-xs-6><input id=lan type=radio name=lan_avk data-ng-model=vm.computation.type data-ng-value=1><label for=lan>Belåning</label></div><div class=col-xs-6><input id=avkastning type=radio name=lan_avk data-ng-model=vm.computation.type data-ng-value=2><label for=avkastning>Avkastning</label></div></div></div><!--                <div class=\"side-nav-row\">\n                        <h3>Lån/Avkastning</h3>\n                        <paper-select-input ng-model=\"vm.computation.type\" choices=\"vm.computations\"></paper-select-input>\n                    </div>--><div class=side-navbar-row ng-show=\"vm.computation.type == 1\" style=margin-top:10px><div class=row><div class=\"col-xs-8 col-md-8\"><div class=info-wrapper><div class=info-content><div class=form-group ng-class=\"(vm.compForm.lan.$error.min && vm.compForm.lan.$touched) ? \'has-error has-feedback\' : \'\'\"><label for=lanet>Lånesumma</label><input type=number class=form-control id=lanet name=lan ng-model=vm.computation.loan min=0> <span class=unit>kr</span></div></div></div></div><!--                            <div class=\"form-group\"\n                                 ng-class=\"((vm.sbpForm.datumGjord.$error.required || vm.sbpForm.datumGjord.$error.max || vm.sbpForm.datumGjord.$error.min) && vm.sbpForm.datumGjord.$touched) ? \'has-error has-feedback\' : \'\'\">\n                                <label for=\"datumGjord\">Skogsbruksplanen upprättad år</label>\n\n                                <input class=\"form-control\"  id=\"datumGjord\" name=\"datumGjord\" ng-model=\"vm.form.datumGjord\" step=\"0.01\" min=\"1980\" max=\"{{ vm.currentYear }}\" required>\n\n                                <span class=\"control-label\" ng-show=\"vm.sbpForm.datumGjord.$error.required && vm.sbpForm.datumGjord.$touched\">Året skogsbruksplanen upprättades måste anges.</span>\n                                <span class=\"control-label\" ng-show=\"!vm.sbpForm.datumGjord.$error.required && vm.sbpForm.datumGjord.$touched && vm.sbpForm.datumGjord.$error.min\">Året skogsbruksplanen upprättades får inte vara tidigare än 1980.</span>\n                                <span class=\"control-label\" ng-show=\"!vm.sbpForm.datumGjord.$error.required && vm.sbpForm.datumGjord.$touched && vm.sbpForm.datumGjord.$error.max\">Året skogsbruksplanen upprättades kan inte vara senare än {{ vm.currentYear }}.</span>\n                            </div>--><div class=\"col-xs-4 col-md-4\"><div class=info-wrapper><div class=info-content><div class=form-group ng-class=\"((vm.compForm.raenta.$error.min || vm.compForm.raenta.$error.max) && vm.compForm.raenta.$touched) ? \'has-error has-feedback\' : \'\'\"><label for=raenta>Ränta</label><input type=number class=form-control id=raenta name=raenta ng-model=vm.computation.interest min=0.001 max=99> <span class=unit>%</span></div></div></div></div></div><div class=has-error><div class=control-label ng-show=\"vm.compForm.lan.$error.min && vm.compForm.lan.$touched\">Lånesumman kan inte vara negativ.</div><div class=control-label ng-show=\"(vm.compForm.raenta.$error.min || vm.compForm.raenta.$error.max) && vm.compForm.raenta.$touched\">Räntan måste vara ett värde mellan 0.001-99%.</div></div><!--                    <div class=\"row\">\n                                                <div class=\"col-xs-8\">\n                                                    Lånesumma:\n                                                    <paper-input name=\"lan\" ng-model=\"vm.computation.loan\" unit=\"kr\" type=\"number\" label-error=\"Fältet behöver vara siffror\"></paper-input>\n                                                </div>\n                                                <div class=\"col-xs-4\">\n                                                    Ränta:\n                                                    <paper-input name=\"raenta\" ng-model=\"vm.computation.interest\" unit=\"%\" type=\"number\" label-error=\"Fältet behöver vara siffror\"></paper-input>\n                                                </div>\n                                            </div>--><!--\n                        <div class=\"info-wrapper\">\n                            <div class=\"info-content\">\n                                <paper-input name=\"pantbrev\" ng-model=\"vm.form.pantbrev\"  label=\"Befintligt pantbrev\" type=\"number\" unit=\"kr\" label-error=\"Fältet behöver vara siffror\"></paper-input>\n                            </div>\n                            <span class=\"info-hover\" ng-show=\"vm.hasDoneFastighet\"></span>\n                            <div class=\"side-navbar-info-box info-box\">\n                                <h4>Pantbrevskostnad</h4>\n                                <p>\n                                    Om befintliga pantbrev inte täcker hela lånet tillkommer en kostnad för att ta ut nya pantbrev.\n                                </p>\n                            </div>\n                        </div>\n                        --></div><div class=side-navbar-row ng-show=\"vm.computation.type == 2\" style=margin-top:10px><div class=row><div class=\"col-xs-12 col-md-12\"><div class=info-wrapper><p>Är Du intresserad av fastighetens avkastningsmöjligheter? Fyll i önskad avkastningsränta i %. Utifrån avkastingsräntan visas här vilket värde Du kan betala för fastigheten och få önskad avkastning.</p></div></div></div><div class=row><div class=\"col-xs-6 col-md-6\"><div class=info-wrapper><div class=info-content><div class=form-group ng-class=\"((vm.compForm.avkastning.$error.min || vm.compForm.avkastning.$error.max) && vm.compForm.avkastning.$touched) ? \'has-error has-feedback\' : \'\'\"><label for=avkastning>Avkastning</label><input type=number class=form-control id=avkastning name=avkastning ng-model=vm.computation.returns min=0.001 max=99> <span class=unit>%</span></div></div></div></div><div class=\"col-xs-6 col-md-6\"><div class=info-wrapper><div class=info-content><div class=form-group><label for=fastighetsvarde>Fastighetsvärde</label><input type=number class=form-control id=fastighetsvarde name=fastighetsvarde ng-model=vm.computation.forestValue ng-disabled=true> <span class=unit>kr</span></div></div></div></div></div><div class=has-error><div class=control-label ng-show=\"(vm.compForm.avkastning.$error.min || vm.compForm.avkastning.$error.max) && vm.compForm.avkastning.$touched\">Avkastningen måste vara ett värde mellan 0.001-99%.</div></div><!--                    <div class=\"info-wrapper\">\n                            <div class=\"info-content\">\n                                <div class=\"row\">\n                                    <div class=\"col-xs-5\">\n                                        Avkastning:\n                                        <paper-input name=\"avkastning\" ng-model=\"vm.computation.returns\" unit=\"%\" type=\"number\" label-error=\"Fältet behöver vara siffror\"></paper-input>\n                                    </div>\n                                    <div class=\"col-xs-7\">\n                                        Fastighetsvärde:\n                                        <paper-input name=\"fastighetsvarde\" ng-model=\"vm.computation.forestValue\" unit=\"kr\" type=\"number\" label-error=\"Fältet behöver vara siffror\" ng-disabled=\"true\"></paper-input>\n                                    </div>\n                                </div>\n                            </div>\n                            <span class=\"info-hover\"></span>\n                            <div class=\"side-navbar-info-box info-box\">\n                                <h4>Avkastning</h4>\n                                <p>\n                                    Är Du intresserad av fastighetens avkastningsmöjligheter?<br />\n                                    Fyll i önskad avkastningsränta i %. Utifrån avkastingsräntan visas här vilket värde Du kan betala för fastigheten och få önskad avkastning. (*)\n                                </p>\n                            </div>\n                        </div>--></div></form></div><!-- RESULTS CONTENT --><div ng-show=\"vm.tabs.RESULTS === vm.activeTab\"><!--                <button class=\"floating-button floating-button-print\" ui-sref=\"print\">\n                </button>--></div></div></div><!-- GRAPHS --><div><div class=chart-container><div class=\"panel panel-paper\"><div class=panel-heading><div class=row><div class=\"col-xs-12 col-md-12\"><div class=charts-heading>Resultat</div><ul class=results-view-toggle><li ng-class=\"!vm.graphActive ? \'active\' : \'\'\" ng-click=\"(vm.graphActive = false)\">Tabell</li><li ng-class=\"vm.graphActive ? \'active\' : \'\'\" ng-click=\"(vm.graphActive = true)\">Diagram</li></ul></div></div></div><div class=\"panel-body no-pad\"><div ng-show=vm.graphActive id=chart_resultat class=chart></div><div ng-show=!vm.graphActive class=chart><div class=results-table><!-------------------- BEGIN TABLE -------------------><div class=table-responsive><table class=\"table table-condensed input-table\"><col ng-repeat=\"val in vm.intaekter.avverkning track by $index\" width=\"{{ 100/(vm.intaekter.avverkning.length + 1) }}%\"><thead><tr><th></th><th ng-repeat=\"val in vm.intaekter.avverkning track by $index\">{{ vm.currentYear + $index }}</th></tr></thead><tbody><!-- INTÄKTER --><tr><th colspan=\"{{vm.intaekter.avverkning.length + 1 }}\">Intäkter</th></tr><tr><td colspan=\"{{vm.intaekter.avverkning.length + 1 }}\"><h6>Slutavverkning</h6></td></tr><tr><td>&nbsp;</td><td ng-repeat=\"val in vm.intaekter.avverkning track by $index\">{{val | numbershort : \'kr\'}}</td></tr><tr><td colspan=\"{{vm.intaekter.avverkning.length + 1 }}\"><h6>Gallring</h6></td></tr><tr><td></td><td colspan={{vm.intaekter.avverkning.length}}>{{vm.intaekter.gallring | numbershort : \'kr\'}}</td></tr><!-- KOSTNADER --><tr><th colspan=\"{{vm.intaekter.avverkning.length + 1}}\">Kostnader</th></tr><tr><td colspan=\"{{vm.intaekter.avverkning.length + 1}}\"><h6>Lån</h6></td></tr><tr><td></td><td ng-repeat=\"val in vm.kostnader.aterbeskogning track by $index\">{{vm.kostnader.lan | numbershort : \'kr\'}}</td></tr><tr><td colspan=\"{{vm.intaekter.avverkning.length + 1}}\"><h6>Återbeskogning</h6></td></tr><tr><td></td><td ng-repeat=\"val in vm.kostnader.aterbeskogning track by $index\">{{val | numbershort : \'kr\'}}</td></tr><tr><td colspan=\"{{vm.intaekter.avverkning.length + 1}}\"><h6>Röjning</h6></td></tr><tr><td></td><td colspan={{vm.intaekter.avverkning.length}}>{{vm.kostnader.rojning | numbershort : \'kr\'}}</td></tr><tr><th colspan={{vm.intaekter.avverkning.length}}>Summa</th></tr><tr><td></td><td ng-repeat=\"val in vm.sum track by $index\">{{val | numbershort : \'kr\' }}</td></tr></tbody></table></div><!-------------------- END TABLE -------------------></div></div></div></div></div><div class=resp-col><div class=\"panel panel-paper\"><div class=panel-heading><div class=charts-heading>Skogsförråd</div></div><div class=\"panel-body no-pad\"><div id=chart_skog class=chart></div></div></div></div></div><!-- END GRAPHS --></div><!--<div class=\"btn-group btn-group-justified\" role=\"group\">\n    <div class=\"btn-group\" role=\"group\">\n        <a href=\"javascript:void(0);\" ng-click=\"vm.activateTab(0)\" class=\"btn btn-default\" data-toggle=\"collapse\">Page One</a>\n    </div>\n    <div class=\"btn-group\" role=\"group\">\n        <a href=\"javascript:void(0);\" ng-click=\"vm.activateTab(1)\" class=\"btn btn-default\" data-toggle=\"collapse\">Page Two</a>\n    </div>\n    <div class=\"btn-group\" role=\"group\">\n        <a href=\"javascript:void(0);\" ng-click=\"vm.activateTab(2)\" class=\"btn btn-default\" data-toggle=\"collapse\">Page Three</a>\n    </div>\n</div>\n<div class=\"ext-content\">\n    External content for <span>{{ vm.activeTab }}</span>\n</div>\n\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"isCollapsed = !isCollapsed\">Toggle collapse Vertically</button>\n<hr>\n<div uib-collapse=\"isCollapsed\">\n    <div class=\"well well-lg\">Some content</div>\n</div>--><!--<uib-tabset active=\"activePills\" vertical=\"false\">\n    <uib-tab index=\"0\" heading=\"Justified\">Justified content</uib-tab>\n    <uib-tab index=\"1\" heading=\"SJ\">Short Labeled Justified content</uib-tab>\n    <uib-tab index=\"2\" heading=\"Long Justified\">Long Labeled Justified content</uib-tab>\n    <uib-tab index=\"3\" heading=\"Another\">Another content</uib-tab>\n</uib-tabset>--><!--<div ng-cloak>\n        <a href=\"javascript:void(0);\" ng-click=\"vm.activateTab(0)\">Page One</a>\n        <a href=\"javascript:void(0);\" ng-click=\"vm.activateTab(1)\">Page Two</a>\n        <a href=\"javascript:void(0);\" ng-click=\"vm.activateTab(2)\">Page Three</a>\n        <div class=\"ext-content\">\n            External content for <span>{{ vm.activeTab }}</span>\n        </div>\n</div>--><!--    <p>Select a tab by setting active binding to true:</p>\n    <p>\n        <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"active = 1\">Select second tab</button>\n        <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"active = 2\">Select third tab</button>\n    </p>\n    <p>\n        <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"tabs[1].disabled = ! tabs[1].disabled\">Enable / Disable third tab</button>\n    </p>\n    <hr />\n\n    <uib-tabset active=\"active\">\n        <uib-tab index=\"0\" heading=\"Static title\">Static content</uib-tab>\n        <uib-tab index=\"$index + 1\" ng-repeat=\"tab in tabs\" heading=\"{{tab.title}}\" disable=\"tab.disabled\">\n            {{tab.content}}\n        </uib-tab>\n        <uib-tab index=\"3\" select=\"alertMe()\">\n            <uib-tab-heading>\n                <i class=\"glyphicon glyphicon-bell\"></i> Alert!\n            </uib-tab-heading>\n            I\'ve got an HTML heading, and a select callback. Pretty cool!\n        </uib-tab>\n    </uib-tabset>\n\n    <hr />\n\n    <uib-tabset active=\"activePill\" vertical=\"true\" type=\"pills\">\n        <uib-tab index=\"0\" heading=\"Vertical 1\">Vertical content 1</uib-tab>\n        <uib-tab index=\"1\" heading=\"Vertical 2\">Vertical content 2</uib-tab>\n    </uib-tabset>\n\n    <hr />--> <!--   <hr />\n\n    Tabbed pills with CSS classes\n    <uib-tabset type=\"pills\">\n        <uib-tab heading=\"Default Size\">Tab 1 content</uib-tab>\n        <uib-tab heading=\"Small Button\" classes=\"btn-sm\">Tab 2 content</uib-tab>\n    </uib-tabset>\n\n    <hr />\n\n    Tabs using nested forms:\n    <form name=\"outerForm\" class=\"tab-form-demo\">\n        <uib-tabset active=\"activeForm\">\n            <uib-tab index=\"0\" heading=\"Form Tab\">\n                <ng-form name=\"nestedForm\">\n                    <div class=\"form-group\">\n                        <label>Name</label>\n                        <input type=\"text\" class=\"form-control\" required ng-model=\"model.name\"/>\n                    </div>\n                </ng-form>\n            </uib-tab>\n            <uib-tab index=\"1\" heading=\"Tab One\">\n                Some Tab Content\n            </uib-tab>\n            <uib-tab index=\"2\" heading=\"Tab Two\">\n                More Tab Content\n            </uib-tab>\n        </uib-tabset>\n    </form>\n    Model:\n    <pre>{{ model | json }}</pre>\n    Nested Form:\n    <pre>{{ outerForm.nestedForm | json }}</pre>\n-->");
$templateCache.put("app/views/login/login.view.html","<div class=\"col-md-6 col-md-offset-3\"><h2>Login</h2><form name=form ng-submit=vm.login() role=form><div class=form-group ng-class=\"{ \'has-error\': form.username.$dirty && form.username.$error.required }\"><label for=username>Username</label><input type=text name=username id=username class=form-control ng-model=vm.username required> <span ng-show=\"form.username.$dirty && form.username.$error.required\" class=help-block>Username is required</span></div><div class=form-group ng-class=\"{ \'has-error\': form.password.$dirty && form.password.$error.required }\"><label for=password>Password</label><input type=password name=password id=password class=form-control ng-model=vm.password required> <span ng-show=\"form.password.$dirty && form.password.$error.required\" class=help-block>Password is required</span></div><div class=form-actions><button type=submit ng-disabled=\"form.$invalid || vm.dataLoading\" class=\"btn btn-primary\">Login</button> <img ng-if=vm.dataLoading src=\"data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==\"><!--<a href=\"#/register\" class=\"btn btn-link\">Register</a>--></div></form></div>");
$templateCache.put("app/views/main/main.html","<navbar></navbar><div ui-view class=full-height-nav></div>");
$templateCache.put("app/views/main/sbp.html","<div class=content ng-controller=MainController><div class=panel ng-repeat=\"post in posts\"><div class=\"panel-heading clearfix\"><h3 class=panel-title>{{ post.title }}</h3><author class=pull-right>{{ post.author.username }}</author></div><p class=well>{{ post.body }}</p></div></div>");}]);